import { messages as utilMessages } from '@sdir/utilities/lib/localization';
import {
  fileCropMessages,
  vesselPreviewMessages,
  certificateCardMessages,
} from '@sdir/blueprint/lib/localization';
import {
  generalMessages,
  healthMessages,
  seagoingMessages,
} from '@sdir/blueprint.aps/lib/components';

/* eslint-disable max-len */
const messages = {
  nb: {
    ...utilMessages.no,
    ...fileCropMessages.nb,
    ...vesselPreviewMessages.nb,
    ...certificateCardMessages.nb,
    ...healthMessages.no,
    ...seagoingMessages.no,
    ...generalMessages.no,
    'language': 'Norsk',
    'userbar.logout': 'Logg ut',
    'userbar.loggedin': 'Logget inn',
    'userbar.as': 'som',
    'userbar.idporten': 'Du er nå innlogget på alle offentlige tjenester med ID-porten',
    'userbar.otherUser': 'Du er nå logget inn som ',
    'userbar.otherUser.info':
      'i Sjøfartsdirektoratets systemer med ID-porten — og har dermed tilgang til flere applikasjoner. Logger du ut herfra vil du også bli logget ut av disse.',
    'userbar.sdirlink': 'Gå til Sjøfartsdirektoratet (sdir.no)',
    'userbar.menu': 'Meny',
    'userbar.skiplink': 'Hopp til hovedinnhold',
    'footer.tagline': '- Den foretrukne maritime administrasjonen',
    'footer.about.title': 'Om sdir.no',
    'footer.about.privacy': 'Personvernerklæring',
    'footer.about.accessibility': 'Tilgjengelighetserklæring',
    'footer.social.title': 'Følg oss',
    'footer.social.facebook': 'Besøk oss på Facebook',
    'footer.social.instagram': 'Besøk oss på Instagram',
    'footer.social.linkedin': 'Besøk oss på LinkedIn',
    'login.org.error':
      'Du må logge inn som person for å se dine kvalifikasjoner. Du er nå logget inn som organisasjon.',
    'general.form.error': 'Obligatorisk felt',
    'general.form.error.invalidnumberformat': 'Ikke et gyldig tallformat.',
    'general.form.error.datemustbeinthepast': 'Datoen må være bakover i tid',
    'general.form.error.startdatemustbebeforeenddate': 'Startdato må være før sluttdato.',
    'general.form.error.phone': 'Telefonnummer kan kun inneholde tall.',
    'general.form.error.phone.length': 'Telefonnummer må inneholde minimum 6 siffer.',
    'general.form.error.phone.maxlength': 'Telefonnummer kan inneholde maksimalt 14 siffer.',
    'general.form.error.postNr': 'Postnummer kan kun inneholde tall.',
    'general.form.error.email': 'Skriv inn en gyldig epostadresse.',
    'general.form.cancel': 'Avbryt',
    'general.form.close': 'Lukk',
    'general.form.save': 'Lagre',
    'general.form.yes': 'Ja',
    'general.form.delete': 'Slette',
    'general.form.submit': 'Send',
    'general.form.next': 'Neste',
    'general.form.goback': 'Tilbake',
    'general.form.back': 'Tilbake til sertifikatoversikt',
    'general.form.deletedocument': 'Slett dokument',
    'general.form.dropfile': 'Slipp filer for å starte opplasting',
    'general.gender.F': 'Kvinne',
    'general.gender.M': 'Mann',
    'general.error.title': 'Feilmelding',
    'general.error.failedtoload': 'Klarte ikke laste inn data',
    'general.error.failedtoloadattachment': 'Klarte ikke laste inn vedlegg',
    'general.error.failedtouploadattachment': 'Klarte ikke laste opp vedlegg',
    'general.error.invalidstateforroute': 'Ugyldig applikasjonstilstand for angitt sti.',
    'general.error.unknownerror': 'Ukjent feil.',
    'general.error.buildsubmitsequence': 'Planlegge innsending',
    'general.error.no.results': 'Ingen treff',
    'general.inputs.country.required': 'Land',
    'general.search.error': 'Klarte ikke gjennomføre søk.',
    'general.search.nomatches': 'Ingen treff.',
    'general.search.minimumchars': 'Skriv inn minst 3 tegn for å søke',
    'general.button.close': 'Lukk',
    'general.button.save': 'Lagre',
    'general.button.edit': 'Endre',
    'general.button.send': 'Send inn',
    'general.button.approve': 'Godkjenn',
    'general.button.reject': 'Avslå',
    'general.button.confirmDelete': 'Bekreft sletting',
    'general.button.downloadpdf': 'Last ned PDF',
    'general.table.viewdetails': 'Se detaljer',
    'general.table.showdetails': 'Vis detaljer',
    'general.table.hidedetails': 'Skjul detaljer',
    'general.table.total': 'Totalt:',
    'general.table.expired': 'Utløp',
    'general.button.delete.application': 'Slett søknad',
    'general.button.open.application': 'Åpne søknad',
    'general.button.open': 'Åpne',
    'general.button.retry': 'Prøv på nytt',
    'general.separator.and': ' og ',
    'general.no': 'Nei',
    'general.yes': 'Ja',
    'submitsteps.success': 'Gjennomført',
    'submitsteps.skipped': 'Hoppet over pga tidligere feil',
    'submitsteps.fileupload': 'Last opp fil {filename}',
    'submitsteps.fileremoval': 'Fjern eksisterende fil {filename}',
    'submitsteps.prevalidateseagoing': 'Validering av fartstid',
    'submitsteps.newseagoing': 'Opprett ny fartstid',
    'submitsteps.updatedseagoing': 'Oppdater eksisterende fartstid',
    'submitsteps.deletedseagoing': 'Slett fjernet fartstid',
    'submitsteps.prevalidatecourse': 'Validering av kursdeltakelse',
    'submitsteps.submitcourse': 'Innsending av kursdeltakelse',
    'submitsteps.requestfailed': 'Operasjon feilet',
    'submitsteps.errors.submitabortedtryagain':
      'Feil oppstod ved en eller flere innsendinger. Gjør eventuelle nødvendige korrigeringer og forsøk igjen.',
    'applicationsOverview.page.title': 'Mine sertifikatsøknader',
    'certificateDashboard.page.title': 'Mine sertifikater og påtegninger',
    'certificateDashboard.page.description':
      'Her ser du alle dine godkjente maritime sertifikater og påtegninger. Du kan også søke om nye.',
    'competenceDashboard.educatia.title': 'Eksamen',
    'competenceDashboard.educatia.registered': 'Du har en godkjent eksamen registrert',
    'competenceDashboard.educatia.created': 'Åpne ny eksamen',
    'competenceDashboard.educatia.current': 'Åpne pågående SRC-eksamen',
    'competenceDashboard.educatia.new': 'Ta SRC-eksamen',
    'competenceDashboard.page.title': 'Mine kompetanser',
    'competenceDashboard.page.description':
      'Her ser du din helseerklæring, registrert fartstid og fullførte kurs.',
    'sidDashboard.page.title': 'Sjøfartskort',
    'sidDashboard.page.description':
      'Her ser du dine godkjente sjøfartskort. Du kan også søke om nye.',
    'sidOverview.button.newapplication': 'Ny søknad om Sjøfartskort',
    'sidCreate.info.duplicate.title': 'Duplikat av sjøfartskort',
    'sidCreate.info.duplicate.text1':
      'Før du kan søke om duplikat av sjøfartskort (ID-kort for sjøfolk), må ditt nåværende kort meldes tapt/mistet.',
    'sidCreate.info.duplicate.text2': 'Dette gjør du ved å:',
    'sidCreate.info.duplicate.text3':
      '1. Gå til søknaden for sjøfartskortet som allerede er godkjent',
    'sidCreate.info.duplicate.text4': '2. Velge <b>Meld tapt/mistet</b> på kortet',
    'sidCreate.info.duplicate.text5':
      'Når kortet er registrert som tapt/mistet, kan du gå videre og sende inn søknad om duplikat.',
    'root.page.title': 'Dine sjøfartstjenester',
    'home.page.title': 'Min side sjøfolk',
    'home.info.digitalcertificate':
      'Sjøfartsdirektoratet utsteder nå kun elektroniske sertifikater, der bilde og signatur ikke er påkrevd. Se mer info på sdir.no',
    'home.info.paymentproblems':
      'Søknader som er sendt inn i perioden 19-21 mai - som har status "venter på betaling" på min side sjøfolk, må betales på nytt for å kunne bli behandlet - dette på grunn av en systemfeil som nå er rettet opp. Betalingen som allerede er trukket fra din konto, vil bli tilbake betalt - dette kan ta inntil 5 virkedager før dette vises på din konto.',
    'home.tile.certificate': 'Sertifikater',
    'home.tile.endorsement': 'Påtegninger',
    'home.tile.seagoingtime': 'Fartstid',
    'home.tile.courseAndEducation': 'Kurs & utdanning',
    'home.tile.competence': 'Tilleggskompetanse',
    'home.tile.assessment': 'Bedømmelse',
    'home.tile.paymentSolution': 'Betalingsoversikt',
    'home.tile.myprofile': 'Min profil',
    'missingdocumentation.page.confirmmodal.receivedtitle': 'Tilleggsinformasjon mottatt',
    'missingdocumentation.page.confirmmodal.receivedinfo':
      'Tilleggsinformasjonen er mottatt og lagret!',
    'missingdocumentation.page.base.allok': 'Alle krav er oppfylt',
    'missingdocumentation.page.base.allok.cert': 'Alle krav til {certificate} er oppfylt',
    'missingdocumentation.page.base.title': 'Følgende krav må dokumenteres',
    'missingdocumentation.page.base.title2': 'Følgende krav er nå dokumentert',
    'missingdocumentation.page.base.title3': 'Følgende krav er oppfylt',
    'missingdocumentation.page.alternative.title':
      'Du må i tillegg dokumentere <b>ett</b> av følgende alternativer',
    'missingdocumentation.page.alternative.title2':
      'Du må dokumentere <b>ett</b> av følgende alternativer',
    'missingdocumentation.page.alternative.titlefulfilled':
      'Du har nå dokumentert disse alternativene',
    'missingdocumentation.page.togglealternatives': 'Vis alle alternativene',
    'missingdocumentation.page.togglealternatives2': 'Tilbakestill visning',
    'endorsements.page.title': 'Påtegninger',
    'endorsements.page.subtitle1': 'Mine påtegninger',
    'endorsements.page.endorsement': 'Påtegning',
    'endorsements.page.dispensation': 'Dispensasjon',
    'endorsements.page.issued': 'Utstedt',
    'endorsements.page.name': 'Påtegning',
    'endorsements.page.limitation': 'I samsvar med nasjonal sertifisering',
    'endorsements.page.minrequirements':
      'Dette sertifikatet er utstedt i samsvar med den internasjonale konvensjonen om standarder for opplæring, sertifisering og vakthold for sjøfolk, 1978, med endringer.',
    'endorsements.noendorsements': 'Du har ingen påtegninger',
    'applications.table.showcompleted': 'Vis ferdigbehandlede søknader',
    'applications.table.hidecompleted': 'Skjul ferdigbehandlede søknader',
    'certificates.page.title': 'Sertifikater og påtegninger',
    'certificates.label.expired': 'Utløpt',
    'certificates.label.daysleft': 'dager igjen',
    'certificates.button.showcertificate': 'Vis sertifikat',
    'certificates.button.receipt': 'Kvittering',
    'certificates.button.showapplication': 'Åpne søknad',
    'certificates.button.reportlost': 'Meld tapt/mistet',
    'certificates.button.newapplication': 'Ny sertifikat søknad',
    'certificates.button.myapplications': 'Mine søknader',
    'certificates.button.myapplications.info': 'Se søknader og kvittering',
    'certificates.empty.title': 'Ingen sertifikater funnet!',
    'certificates.requestmoreinfo.title': 'Vi trenger tilleggsinformasjon!',
    'certificates.requestmoreinfo.description':
      'I søknad om <b>{certificate}</b> trenger vi mer informasjon.',
    'certificates.requestmoreinfo.button': 'Legg inn mer informasjon',
    'certificates.table.showexpired': 'Vis utgåtte sertifikater',
    'certificates.table.hideexpired': 'Skjul utgåtte sertifikater',
    'certificates.table.status.valid': 'Gyldig',
    'certificates.table.status.invalid': 'Ugyldig',
    'certificates.table.label.activeapplications': 'Aktive søknader',
    'certificates.table.label.application': 'Søknad',
    'certificates.table.label.certificate': 'Sertifikat',
    'certificates.table.label.dispensation': 'Dispensasjon',
    'certificates.table.label.validto': 'Gyldig til',
    'certificates.table.label.expiry': 'Utløpsdato',
    'certificates.table.label.status': 'Status',
    'certificates.table.label.created': 'Sist lagret',
    'certificates.table.label.issued': 'Utstedt dato',
    'certificates.table.label.documentnumber': 'Dokumentnummer',
    'certificates.alert.title': 'Viktig informasjon',
    'certificates.alert.subtitle': 'Opprettelse av søknad og innsending av tilleggsinformasjon',
    'certificates.alert.description':
      'På grunn av overgang til et nytt IT-system, er det for øyeblikket ikke mulig å opprette søknader eller sende inn tilleggsinformasjon. Vi jobber for å forbedre våre tjenester, og funksjonene vil være tilgjengelige igjen fra mandag. Vi beklager eventuelle ulemper dette måtte medføre og takker for din forståelse.',
    'certificates.page.subtitle': 'Mine søknader',
    'certificates.page.subtitle2': 'Mine sertifikater',
    'certificates.page.subtitle3': 'Utgåtte sertifikater',
    'certificates.page.approvedFilter': 'Se godkjente',
    'certificates.page.newApp': 'Start ny søknad',
    'certificates.errors.unabletoloadcertificates': 'Kunne ikke hente sertifikater',
    'certificates.novalidcertificates': 'Du har ingen gyldige sertifikater',
    'certificates.noinvalidcertificates': 'Du har ingen utgåtte sertifikater',
    'certificatetile.expirydate': 'Utløpsdato',
    'certificatetile.validfromdate': 'Gyldig fra',
    'certificatetile.status.valid': 'Gyldig',
    'certificatetile.status.expired': 'Utgått',
    'certificatetile.status.cancelled': 'Kansellert',
    'certificatetile.status.inactive': 'Inaktiv',
    'certificate.page.title': 'Sertifikat',
    'certificate.app.type': 'Søknadstype',
    'app.type.duplicate': 'Duplikat',
    'app.type.firstTime': 'Førstegang',
    'app.type.renewal': 'Fornyelse',
    'app.type.upgrade': 'Oppgradering',
    'filegroup.chosenfile': 'Valgt fil',
    'filegroup.deletefile': 'Slette dokument',
    'filegroup.addfiles': 'Last opp flere filer',
    'newapp.steps.certificate': 'Sertifikattype',
    'newapp.steps.qualifications': 'Kvalifikasjoner',
    'newapp.steps.contactinfo': 'Kontaktinformasjon',
    'newapp.steps.photoandsignature': 'Bilde og signatur',
    'newapp.steps.summary': 'Oppsummering',
    'newapp.steps.payment': 'Betaling',
    'newapp.steps.payment.complete': 'Gå videre til oppsummering',
    'newapp.steps.payment.no.charges': 'Kunne ikke finne noen gebyr',
    'newapp.steps.payment.failed': 'Kunne ikke fullføre betaling',
    'newapp.steps.payment.failed.charges':
      'Opprettelse av gebyr tar lenger tid enn planlagt. Prøv å oppdatere siden om en liten stund.',
    'newapp.steps.payment.loadingmessage': 'Dette kan ta litt tid. Vennligst vent.',
    'newapp.steps.payment.paid':
      'Betaling har allerede blitt utført. Trykk knappen under for å videre til søknad oversikt.',
    'newapp.steps.payment.go.to.application.details': 'Gå til søknad oversikt',
    'select.certificate.title': 'Velg sertifikat',
    'certificate.type': 'Sertifikattype',
    'certificate.type.renewal.title': 'Fornyelse av sertifikat',
    'certificate.type.renewal.info':
      'Du kan ikke søke om fornyelse før det originale sertifikatet har mindre enn 6 måneders utløpsdato. Søknad om fornyelse kan kun gjøres når sertifikatet nærmer seg utløp.',
    'select.certificate.h1': 'Nytt sertifikat:',
    'qualification.descriptionBox.heading': 'Obligatoriske kvalifikasjoner',
    'qualification.descriptionBox.steplabel': 'Steg {current} av {total}',
    'qualification.descriptionBox.contents':
      'For å få utstedt dette sertifikatet må du oppfylle de obligatoriske kravene i steg 1.<linebreak></linebreak>' +
      'Du må også oppfylle ett av alternativene i steg 2.<linebreak></linebreak>' +
      'For kvalifikasjoner som ikke er registrert i vårt system vil det være mulig å laste opp dokumentasjon som vedlegg. ' +
      'Merk at søknaden da vil gå til manuell behandling.',
    'qualification.description.heading': 'Beskrivelse',
    'qualification.tile.seagoing': 'Fartstid',
    'qualification.tile.education': 'Utdanning',
    'qualification.tile.competence': 'Kompetanse',
    'qualification.tile.health': 'Helseerklæring',
    'qualification.doc.edit': 'Endre dokumentasjon',
    'qualification.doc.upload': 'Last opp dokumentasjon',
    'qualification.confirm': 'Jeg bekrefter ovenstående',
    'qualification.course.upload': 'Last opp kursbevis',
    'qualification.signature.valid': 'Signatur er dokumentert',
    'qualification.signature.required': 'Signatur må dokumenteres',
    'qualification.photo.valid': 'Bilde er dokumentert',
    'qualification.photo.required': 'Bilde må dokumenteres',
    'qualification.overrule.title':
      'Har du nødvendig kompetanse som oppfyller kravene for sertifikatet, men systemet er uenig med deg?',
    'qualification.overrule.comment': 'Kommentar',
    'qualification.overrule.toggle':
      'Jeg ønsker allikevel at en saksbehandler skal se på søknaden min',
    'qualification.certificatecheck.title':
      'Jeg bekrefter at jeg har rett til å føre båtførerbevispliktig fritidsfartøy, ' +
      'og er klar over at det kan være straffbart å gi uriktige opplysninger.',
    'qualification.certificatecheck.tooltip':
      'Med båtførerbevispliktig fritidsfartøy menes fritidsbåter (ink. vannscooter) med ' +
      'lengde over 8 meter eller som har motor med større ytelse enn 25 HK. Båtførerbevis, ' +
      'norsk ICC, eller høyere sertifikater (D5L/A, D6-D1) gir rett til å føre slike fartøy. ' +
      'Andre sertifikat/bevis kan også gi en slik rett, ta kontakt på post@sdir.no ved slike ' +
      'tilfeller. Personer født før 1.1.1980 har automatisk rett til å føre ' +
      'båtførerbevispliktig fritidsfartøy uten noen form for sertifikat/bevis.',
    'qualification.certificatecheck.error': 'Du må bekrefte for å gå videre',
    'qualification.errors.infoincomplete': 'Ufullstendig registering av dokumentasjon',
    'qualification.errors.uploaddoctocontinue':
      'Du kan ikke gå videre før du har lastet opp manglende dokumentasjon.',
    'qualification.errors.requirementnotmet':
      'Du kan ikke fortsette uten å tilfredstille kriteriet',
    'additionalqualifications.infobox.heading': 'Tilleggskvalifikasjoner',
    'additionalqualifications.alternative': 'Alternativ {number}',
    'addcourse.organizations': 'Utdanningsinstitusjon',
    'addcourse.education': 'Utdanning',
    'addcourse.date': 'Fullført/utstedt',
    'addcourse.foreignCourse': 'Utenlandsk kursholder',
    'addcourse.education.title': 'Opplasting av vitnemål',
    'addcourse.get.course.error': 'Kunne ikke hente Utdanningsinstitusjoner',
    'addcourse.searchcourses': 'Søk i kurs',
    'addcourse.nomatchingcourse': 'Kurset er ikke tilgjengelig ved valgt utdanningsinstitusjon',
    'addcourse.changeforeigncourse.title': 'Endre utenlandsk kurs',
    'addcourse.changeforeigncourse':
      'Ved endring til/fra utenlandsk kurs må du slette alle dokumenter og legge dem til på nytt. Vennligst gjør dette før du fortsetter.',
    'addseagoing.title': 'Fartstid',
    'addseagoing.upload.previous': 'Velg blant tidligere opplastet filer',
    'addseagoing.upload.new': 'Last opp ny dokumentasjon',
    'addseagoing.button.new': 'Ny fartstid',
    'addseagoing.apply.for': 'For å søke om {cert} må du dokumentere følgende fartstid:',
    'addseagoing.fetch.error': 'Kunne ikke hente fartstid.',
    'addseagoing.save.error.toobig': 'Filen er for stor til å lastes opp.',
    'addseagoing.relevant.heading':
      'Fartstid lastet opp i søknad som må godkjennes av saksbehandler',
    'addseagoing.notrelevant.heading': 'Fartstid lastet opp i søknad som ikke oppfyller kravet',
    'addseagoing.approved.heading': 'Tidligere godkjent fartstid som oppfyller kravet',
    'addseagoing.approvedunused.heading': 'Tidligere godkjent fartstid som ikke oppfyller kravet',
    'addseagoing.confirm.heading': 'Ufullstendig dokumentasjon',
    'addseagoing.confirm.description':
      'Du mangler dokumentasjon for <b>{days}</b> dager fartstid. Ønsker du å fortsette søknadsprosessen uten fullstendig fartstidsdokumentasjon?',
    'addseagoing.heading': 'Opplasting av fartstid',
    'addseagoing.description': 'Legg inn fartstiddata fra vedlegg',
    'addseagoing.employer': 'Arbeidsgiver',
    'addseagoing.vessel': 'Fartøy',
    'addseagoing.table.jobTitle': 'Yrkestittel',
    'addseagoing.table.periodStart': 'Periode start',
    'addseagoing.table.periodEnd': 'Periode slutt',
    'addseagoing.table.hours': 'Timer per dag',
    'addseagoing.table.attachments': 'Attachments',
    'addseagoing.vessel.vesselsearch': 'Søk på navn, imo, kjenningssignal ...',
    'addseagoing.vessel.addmanualvessel': 'Legg til fartøy manuelt',
    'addseagoing.vessel.searchvessel': 'Søk etter NIS/NOR fartøy',
    'addseagoing.vessel.newVessel.registry': 'Register',
    'addseagoing.details.jobtitle': 'Velg yrkestittel',
    'addseagoing.details.periodstart': 'Periode start',
    'addseagoing.details.periodend': 'Periode slutt',
    'addseagoing.details.totalhours': 'Totalt antall timer i perioden',
    'addseagoing.details.hoursperday': 'Antall timer per dag',
    'addseagoing.details.sethoursperday': 'Oppgi timer per dag',
    'addseagoing.details.settotalhours': 'Totalt antall timer i perioden',
    'addseagoing.details.hourstooltip':
      'Du kan legge inn fartstiden som antall arbeidstimer samlet i perioden du har oppgitt. ' +
      'Alternativt kan du legge inn antall timer pr. arbeidsdag, ' +
      'og systemet vil regne ut totalen for deg basert på start- og sluttdato.',
    'addseagoing.details.mustaddone': 'Må legge til minst en fartstidperiode',
    'addseagoing.details.add': 'Legg til fartstid',
    'addseagoing.addmoreseagoingtime': 'Legg til mer fartstid',
    'addseagoing.errors.noseagoingtimeadded': 'Ingen fartstid registrert',
    'addseagoing.button.edit': 'Endre fartøy',
    'addseagoing.missingdays':
      '<i>{requirement} <b>Du mangler dokumentasjon på {days} dager fartstid</b></i>',
    'addseagoing.missingdays2':
      'Du mangler dokumentasjon på <b>{days}</b> dager fartstid for kravet "{requirement}"',
    'addseagoing.alldocumented': 'Du har dokumentert nok fartstid for dette kravet',
    'addseagoing.vessel.togglevessel': 'Vis/skjul fartøy',
    'addseagoing.incomplete.tooltip':
      'Dersom du mener fartstiden din oppfyller gjeldende krav, er det fortsatt mulig å sende inn søknaden. For å gjøre dette må du trykke på "neste" knappen. Du vil da komme tilbake til søknadsoversikten. Rull helt ned på siden og velg at en saksbehandler skal se på søknaden din.',
    'addseagoing.incomplete.tooltip2':
      'Dersom du mener fartstiden din oppfyller gjeldende krav, er det fortsatt mulig å sende inn søknaden. For å gjøre dette må du trykke på "ok" knappen. Du vil da komme tilbake til søknadsoversikten. Rull helt ned på siden og velg at en saksbehandler skal se på søknaden din.',
    'addassessment.assessor.title': 'Fyll inn informasjon om assessor:',
    'addassessment.assessor.firstname': 'Assessor sitt fornavn og mellomnavn',
    'addassessment.assessor.lastname': 'Assessor sitt etternavn',
    'addassessment.assessor.personalidentitynumber': 'Assessor sitt D-/Fødselsnummer',
    'addassessment.assessor.invalidpersonnumber': 'Ugyldig d-/fødselsnummer',
    'addassessment.assessor.search': 'Personsøk',
    'addassessment.assessor.label': 'Ansvarlig',
    'addassessment.restore': 'Gjenopprett bedømmelse',
    'addassessment.periodstart': 'Periode start',
    'addassessment.periodend': 'Periode slutt',
    'addassessment.assessmentcode': 'Bedømmelse',
    'addassessment.assessor.personnotfound': 'Fant ingen treff',
    'addassessment.prevalidate': 'Validering av bedømmelse',
    'addassessment.submit': 'Innsending av bedømmelse',
    'addassessment.submit.error': 'Kunne ikke oppdatere bedømmelse',
    'addhealth.heading': 'Helseerklæring',
    'addhealth.description': 'Legg til dokumentasjon av din helseerklæring her',
    'addcompetence.heading': 'Tilleggskompetanse',
    'addcompetence.description': 'Legg til dokumentasjon av din tilleggskompetanse her',
    'addPhoto.heading': 'Profilbilde',
    'addPhoto.instruction1':
      'Ansiktsfotoet skal vise ansiktet til innehaveren slik vedkommende ser ut i dag',
    'addPhoto.instruction2':
      'Ansiktet skal vise hele hodet og øverste del av skuldrene og være tatt rett forfra',
    'addPhoto.instruction3': 'Blikket skal være rettet mot kameraets linse',
    'addPhoto.instruction4': 'Begge øyne, øyebryn og ørene skal være helt synlige',
    'addPhoto.instruction5': 'Ansiktsuttrykket skal være nøytralt og munnen skal være lukket',
    'addPhoto.instruction6':
      'Bakgrunnen skal være hvit, og ansikt og bakgrunn skal være jevnt belyst',
    'addPhoto.instruction7':
      'Briller og hodeplagg skal ikke benyttes (visse unntak for religiøse hodeplagg)',
    'addPhoto.instruction7.tooltip':
      'Personer kan av religiøse eller andre særskilte grunner, for eksempel ved sykdom, bruke hodeplagg på fotografiet når det er forventet at vedkommende vil bruke tilsvarende hodeplagg i fremtidige kontroller. Hodeplagget må ikke tildekke noe av ansiktet eller mer av hodet enn det som er nødvendig. Hodeplagget må ikke være så stramt at det endrer ansiktets naturlige fasong.',
    'addPhoto.instruction8': 'Skjerf, vesker og yttertøy tas av før man skal fotograferes',
    'addPhoto.imageformat': 'Vedlegg må lastes opp i JPG- eller PNG-format.',
    'addPhoto.filesize': 'Filen er for stor. Maksimal størrelse er 10 MB.',
    'addPhoto.upload': 'Last opp ny fil',
    'addSignature.heading': 'Signatur',
    'addSignature.image.error':
      'Bildet har for lav oppløsning. Minimum størrelse er 1000 × 200 piksler.',
    'addSignature.instruction1': 'Skriv navnetrekket for hånd på et hvitt, ulinjert ark',
    'addSignature.instruction2': 'Det skal ligne navnetrekket i pass/ID og være lett å lese',
    'addSignature.instruction3': 'Unngå store variasjoner i bokstavene',
    'addSignature.instruction4': 'Bruk sort penn',
    'addSignature.instruction5': 'Bildet av navnetrekket må være av god kvalitet',
    'addforeignid.heading': 'Gyldig id',
    'addforeignid.description': 'Legg til dokumentasjon av gyldig id her',
    'addcertificate.heading': 'Sertifikat',
    'addcertificate.description': 'Legg til dokumentasjon av ditt sertifikat her',
    'addnorwegianid.heading': 'Gyldig id',
    'addassessment.heading': 'Bedømmelse',
    'addassessment.description': 'Legg til dokumentasjon av din bedømmelse her',
    'addconfirmation.heading': 'Bekreftelse',
    'addconfirmation.description': 'Legg til dokumentasjon av din bekreftelse her',
    'contactinfo.title': 'Kontaktinformasjon',
    'contactinfo.dialCode': 'Landskode',
    'contactinfo.phone': 'Telefonnummer',
    'contactinfo.email': 'Epostadresse',
    'contactinfo.gender': 'Kjønn',
    'contactinfo.differentaddress': 'Lever sertifikat til annen adresse',
    'contactinfo.address': 'Adresse',
    'contactinfo.navn': 'Navn',
    'contactinfo.streetaddress': 'Gateadresse',
    'contactinfo.streetaddress.optional': 'Gateadresse (Valgfritt)',
    'contactinfo.receiver': 'Mottaker',
    'contactinfo.postnr': 'Postnummer',
    'contactinfo.postlocation': 'Poststed',
    'contactinfo.country': 'Land',
    'contactinfo.deliveryaddress': 'Leveringsadresse',
    'contactinfo.noaddressfound': 'Registrert adresse mangler i Folkeregisteret.',
    'contactinfo.freginfo':
      'Oppgitt adresse er hentet i Folkeregisteret. Dersom adressen feil, må den oppdateres i Folkeregisteret før søknaden kan saksbehandles.',
    'contactinfo.loading': 'Laster inn...',
    'contactinfo.error': 'Kunne ikke laste opp kontaktinfo',
    'photoandsignature.uploadphoto': 'Klikk for å laste opp bilde',
    'photoandsignature.uploadnewphoto': 'Klikk for å laste opp nytt bilde',
    'photoandsignature.uploadsignature': 'Klikk for å laste opp signatur',
    'photoandsignature.uploadnewsignature': 'Klikk for å laste opp ny signatur',
    'photoandsignature.keepoldimages': 'Trykk neste for å beholde ditt nåværende bilde og signatur',
    'photoandsignature.helptext':
      'Her kan du justere bildet ditt. Du kan se en forhåndsvisning av resultatet til høyre. Du zoomer ved å rulle med musen. Trenger du flere verktøy er disse under bildet. Flytt bildet slik at det ser bra ut i det valgte området.',
    'photoandsignature.photo': 'Bilde',
    'photoandsignature.signature': 'Signatur',
    'photoandsignature.requirement.header': 'Requirement og rules for bilde og signatur',
    'photoandsignature.requirement.section.1.subheader': 'Eksisterende bilde og signatur:',
    'photoandsignature.requirement.section.1.content':
      'Har du alt gyldig bilde (av nyere dato) eller signatur behøver du ikke å laste opp nytt.' +
      'Har du bilde av eldre dato anbefaler vi deg at du laster opp nytt bilde som møter kravene ' +
      'listet opp under.',
    'photoandsignature.requirement.section.2.subheader': 'Bildet:',
    'photoandsignature.requirement.section.2.content':
      '• Det skal være av nyere dato \n' +
      '• Pass på at bakgrunnen er hvit eller nøytral \n' +
      '• Kun hodet og skuldrene skal være med \n' +
      '• Se rett i kamera og pass på at ansiktet er jevnt belyst \n' +
      '• Begge øyne, øyebryn og ørene skal være helt synlige \n' +
      '• Ansiktet til passøkeren skal være avbildet rett forfra \n' +
      '• Bakgrunnen skal være jevnt belyst \n' +
      '• Ansiktet skal være jevnt belyst \n',
    'photoandsignature.requirement.section.3.subheader': 'Signaturen:',
    'photoandsignature.requirement.section.3.content':
      '• Signaturen skal være i svart penn på hvit bakgrunn \n' +
      '• Pass på at bakgrunnen er hvit eller nøytral',
    'photoandsignature.steps.uploadnewphoto': 'Legg ved nytt bilde',
    'photoandsignature.steps.uploadnewcroppedphoto': 'Legg ved nytt beskåret bilde',
    'photoandsignature.steps.uploadnewsignature': 'Legg ved ny signatur',
    'photoandsignature.steps.uploadnewcroppedsignature': 'Legg ved ny beskåret signatur',
    'summarystep.confirmdraft': 'Klargjør søknad for betaling',
    'summarystep.yourqualifications': 'Dine kvalifikasjoner',
    'summarystep.photoandsignature.addedphoto': 'Nytt bilde lastet opp',
    'summarystep.photoandsignature.useexistingphoto': 'Eksisterende bilde brukes',
    'summarystep.photoandsignature.addedsignature': 'Ny signatur lastet opp',
    'summarystep.photoandsignature.useexistingsignature': 'Eksisterende signatur brukes',
    'summarystep.photoandsignature.nochanges': 'Ingen endringer',
    'summarystep.expirydate': 'Sertifikatet vil få denne utløpsdatoen',
    'summarystep.expirydate.info': 'Vis informasjon om utløpsdato',
    'summarystep.expirydate.disagree.header': 'Hvorfor får jeg kort utløpsdato?',
    'summarystep.expirydate.disagree.info':
      'Mange sertifikater får utløpsdato basert på gjennomført kurs. Dersom du har gjennomført nytt kurs, men dette ikke er registrert av kurssenter kan det forklare den korte utløpsdatoen. Be kurssenter registrere inn kurset for deg, eller benytt deg av overprøve og last opp relevant kursbevis.',
    'summarystep.expirydate.overrule':
      'Jeg er uenig i utløpsdatoen og ønsker at en saksbehandler skal se på søknaden',
    'summarystep.expirydate.overrule.checklabel':
      'Jeg er uenig i utløpsdatoen og ønsker at en saksbehandler skal vurdere utløpsdatoen til sertifikatet',
    'summarystep.charge': 'Gebyr',
    'summarystep.charge.amount': 'Pris',
    'summarystep.charge.unknownamount': 'Ukjent',
    'summarystep.consent.sid.title':
      'Jeg bekrefter at opplysningene er korrekte, og er oppmerksom på at det er straffbart å levere inn falsk dokumentasjon. Jeg er også oppmerksom på at dersom søknad om <b>Sjøfartskort ikke blir innvilget vil innbetalt gebyr ikke bli tilbakebetalt</b>.',
    'summarystep.consent.title':
      'Jeg bekrefter at opplysningene er korrekte, og er oppmerksom på at det er straffbart å levere inn falsk dokumentasjon. Jeg er også oppmerksom på at dersom søknad om <b>sertifikat, bevis eller påtegning ikke blir innvilget vil innbetalt gebyr ikke bli tilbakebetalt</b>.',
    'summarystep.consent.description':
      'Jeg bekrefter at opplysningene er korrekte og samtykker i at de kan benyttes for vurdering av sertifikatsøknader. Jeg forplikter meg til å - ikke misbruke sertifikatet - å melde fra til Sjøfartsdirektoratet dersom kravene til sertifikatet ikke lenger er oppfylt - å returnere alle sertifikater som er utstedt av Sjøfartsdirektoratet ved suspensjon eller tilbaketrekking av sertifiseringen. Jeg er oppmerksom på at det er straffbart å levere inn falsk dokumentasjon (jf. straffeloven § 361 og § 221, og at jeg blir politianmeldt hvis jeg leverer falsk dokumentasjon). Jeg er også oppmerksom på at dersom søknad om sertifikat, bevis eller påtegning ikke blir innvilget vil innbetalt gebyr ikke bli tilbakebetalt (jf. OR-2009-12-21-1739 § 3). Dette gjelder også ved søknad om feil sertifikat.',
    'summarystep.payment.info':
      'Når du går til betaling, vil søknaden låses i 2 timer mens vi venter på din betaling. Velger du å ikke betale innen tiden, vil søknaden åpnes slik at du kan endre på den igjen.',
    'qualificationsummary.additionalalternative': 'Tilleggskvalifikasjoner - Alternativ {number}',
    'qualificationsummary.error.incomplete': 'Dokumentasjon mangler eller er mangelfull',
    'whatsNext.heading': 'Hva skjer nå?',
    'whatsNext.heading.print': 'Trykking av sertifikat',
    'whatsNext.heading.time': 'Leveringstid',
    'whatsNext.heading.abroad': 'Levering utland',
    'whatsNext.info.print':
      'Ditt sertifikat er nå sendt i kø til vårt trykkeri, hvor vi vil produsere ditt fysiske sertifikat. I mellomtiden vil ditt nye sertifikat bli synlig under «mine sertifikater».',
    'whatsNext.info.time':
      'Sertifikatet sendes til din folkeregistrerte adresse så lenge du ikke har huket av for levering til annen adresse. Er du usikker kan du se oppgitt leveringsadresse under «Bestiller» på denne siden. Estimert vil produksjonen av ditt sertifikat ta 4-5 virkedager i tillegg kommer postens leveringstid på 1-4 dager basert på hvor i landet du ønsker sertifikatet levert.',
    'whatsNext.info.abroad':
      'Vennligst merk at sertifikater levert til utlandet har noe lengre leveringstid.',
    'courseandeducation.header.description':
      'Her finner du en oversikt over kurs og utdanning registrert på deg.<br></br>' +
      'Utdanningsinstitusjoner registrerer inn kurs og utdanning til Sjøfartsdirektoratet.',
    'courseandeducation.subheader.sideinfobox': 'Mangler vitnemål eller kursbevis?',
    'courseandeducation.description.sideinfobox':
      'Ta kontakt med de som har utstedt vitnemålet eller kursbeviset dersom det ikke er tilgjengelig på “Min Side Sjøfolk”. ' +
      'Du har selv mulighet til å sende inn vitnemål eller kursbevis gjennom en sertifikatsøknad.<br></br>' +
      'Merk at søknader med vedlegg går til manuell behandling.',
    'back.to.dashboard': 'Tilbake til dashboard',
    'courseandeducation.notfound': 'Ingen kurs ble funnet',
    'courseandeducation.table.hideexpired': 'Skjul utgåtte',
    'courseandeducation.table.showexpired': 'Vis utgåtte',
    'courseandeducation.table.subheader1': 'Kurs/utdanning',
    'courseandeducation.table.subheader2': 'Organisasjon',
    'courseandeducation.table.subheader3': 'Status',
    'courseandeducation.table.subheader4': 'Gjennomført',
    'courseandeducation.table.subheader5': 'Utløpsdato',
    'seagoing.title': 'Fartstid',
    'seagoing.vessel.title': 'Fartøy',
    'seagoing.description':
      'Her finner du oversikt over din fartstid som er rapportert inn elektronisk av arbeidsgiver.<br></br>' +
      'Det er kun fartstid som er registrert inn i nyere tid som er tilgjengelig her. Vær oppmerksom på at det ikke er alle rederier som rapporterer inn elektronisk fartstid.<br></br>' +
      'Du kan ikke innrapportere egen fartstid her. Sjøfartsdirektoratet har ikke anledning til å registrere inn fartstid på vegne av rederi.',
    'seagoing.missingseagoingtime': 'Manglende fartstid?',
    'seagoing.missingseagoingtimedescription':
      'Ved mangler eller feil ber vi deg ta kontakt med arbeidsgiver.',
    'seagoing.notfound': 'Ingen fartstid ble funnet',
    'seagoing.table.period': 'Period',
    'seagoing.table.vessel': 'Fartøy',
    'seagoing.table.occupation': 'Stilling',
    'seagoing.table.seagoingtime': 'Fartstid',
    'seagoing.table.totaltimedays': 'Total tid (dag)',
    'seagoing.table.childtable.vessel': 'Fartøy',
    'seagoing.table.childtable.period': 'Periode',
    'seagoing.table.childtable.employer': 'Arbeidsgiver',
    'seagoing.ok.tooltip': 'Oppfyller kravet',
    'seagoing.warning.tooltip': 'Oppfyller ikke kravet',
    'seagoing.days': 'dager',
    'seagoing.toggle.show.five.year.old': 'Vis fartstid eldre enn fem år',
    'seagoing.toggle.hide.five.year.old': 'Skjul fartstid eldre enn fem år',
    'seagoing.loginfo.table.reportedby': 'Meldt av',
    'seagoing.loginfo.table.date': 'Dato',
    'profile.title': 'Min profil',
    'profile.description': 'Her er en oversikt over opplysninger som er registrert på deg.',
    'profile.personalinfo': 'Personlige opplysninger',
    'profile.personalidentitynumber': 'D-/Fødselsnummer',
    'profile.nationality': 'Nasjonalitet',
    'profile.otherinfo': 'Andre opplysninger',
    'profile.share.title': 'Del min kompetanse',
    'profile.share.search.placeholder': 'Organisasjon ...',
    'profile.share.button': 'Del',
    'profile.share.header': 'Del kompetanse',
    'profile.share.description': 'Vil du angi en utløpsdato for delingen?',
    'profile.shared.header': 'Deling',
    'profile.shared.title': 'Min deling',
    'profile.shared.requests.title': 'Mine delingsforespørsler',
    'profile.shared.table.organization': 'Organisasjon',
    'profile.shared.table.created': 'Opprettet',
    'profile.shared.table.expires': 'Utløpsdato',
    'profile.shared.table.status': 'Status',
    'profile.shared.table.status.Approved': 'Godkjent',
    'profile.shared.table.status.Pending': 'Venter',
    'profile.shared.table.status.Rejected': 'Avslått',
    'profile.shared.noresults.title': 'Ingen aktive delinger',
    'profile.shared.noresults.text':
      'Når du deler kompetansen din med en organisasjon, vises det her.',
    'profile.sharerequests.noresults.title': 'Ingen delingsforespørsler',
    'profile.sharerequests.noresults.text':
      'Her vises forespørsler om å dele kompetansen din med en organisasjon.',
    'valid': 'Gyldig',
    'invalid': 'Ugyldig',
    'payment.summary.type': 'Type',
    'payment.summary.charge': 'Gebyr',
    'payment.summary.amount': 'Beløp',
    'certificate.overview': 'Sertifikatoversikt',
    'certificate.applications.empty': 'Ingen søknader funnet',
    'certificate': 'Sertifikat',
    'certificate.status.invalid': 'Utløpt sertifikat',
    'certificate.status.valid': 'Gyldig sertifikat',
    'certificate.app.exists.button': 'Gå til påbegynt søknad',
    'certificate.app.exists.head': 'Påbegynt søknad',
    'certificate.app.exists.text':
      'Det eksisterer allerede en påbegynt søknad med samme sertifikattype.',
    'certificate.footer.text.part1':
      'The lawful holder of this endorsement may serve in the capacity listed above or ' +
      'capacities specified in the applicable safe manning requirements of the Administration.',
    'certificate.footer.text.part2': 'Name/ signature of duty authorised official',
    'certificate.create.warning':
      'Søknadsprosessen tar litt tid. Vi har mottat søknaden din, og snart vil den vises i søknadsoversikten',
    'certificate.create.error': 'Kunne ikke opprette søknad',
    'certificate.create.fetch.error': 'En feil har oppstått',
    'certificate.actions.inactive.heading': 'Sertifikatet har status inaktiv',
    'certificate.actions.inactive.description': 'Sertifikatet vil bli gyldig: ',
    'certificate.actions.duplicate.heading': 'Bestill duplikat',
    'certificate.actions.duplicate.description':
      'Gebyr for utstedelse av duplikat følger av forskrift 21. desember 2009 nr. ' +
      '1739 om gebyr for utstedelse av sertifikater. Se priser i <a>§ 4 i forskriften</a>',
    'certificate.actions.duplicate.actiontext': 'Bestill duplikat',
    'certificate.actions.orderprint.heading': 'Bestill fysisk sertifikat',
    'certificate.actions.orderprint.description':
      'Det er ikke gebyr ved bestilling av fysisk sertifikat av båtførerbevis og ICC følger av ' +
      'forskrift 21. desember 2009 nr. 1739 om gebyr for utstedelse av sertifikater. ' +
      'Se priser i <a>§ 6 i forskriften.</a>',
    'certificate.actions.orderprint.actiontext': 'Bestill fysisk sertifikat',
    'certificate.actions.orderprint.confirmation':
      'Din bestilling er mottatt. Sertifikatet vil bli sendt i løpet av få dager',
    'certificate.shipmentaddress': 'Leveringsadresse',
    'certificate.printlanguage.label': 'Utskriftsspråk',
    'certificate.printlanguage.english': 'Engelsk',
    'certificate.printlanguage.norwegianbokmal': 'Norsk bokmål',
    'certificate.printlanguage.norwegiannynorsk': 'Norsk nynorsk',
    'certificate.orderprint.errors.missingaddress': 'Mangler adresse',
    'certificate.print.printordered': 'Du har bestilt fysisk utgave av dette sertifikatet',
    'certificate.printstatus.unprocessed': 'Venter på behandling',
    'certificate.printstatus.notstarted': 'Lagt til i utskiftskø',
    'certificate.printstatus.started': 'Utskrift påbegynt',
    'certificate.printstatus.ok': 'Utskrift gjennomført',
    'certificate.printstatus.error': 'Feil under utskrift',
    'certificate.printstatus.unknown': 'Ukjent status',
    'certificate.actions.renewal.heading': 'Søk om fornyelse',
    'certificate.actions.renewal.description':
      'Her kan du se saksbehandlingstiden for personlige sertifikater: ',
    'certificate.actions.renewal.link':
      'Saksbehandlingstid for personlige sertifikater - Sjøfartsdirektoratet',
    'certificate.actions.renewal.actiontext': 'Søk fornyelse',
    'application.status': 'Søknadsstatus',
    'home.tile.health': 'Helseerklæring',
    'health.notfound': 'Ingen helsesjekk ble funnet',
    'health.header.description': 'Her ser du din helseerklæring.',
    'health.subheader.sideinfobox': 'Mangler helseerklæring?',
    'health.description.sideinfobox':
      'Helseerklæring for sjøfolk skal registreres av godkjent sjømannslege. ' +
      'Dersom helseerklæringen ikke er tilgjengelig, må du kontakte din sjømannslege.',
    'competence.header.description':
      'Tilleggskompetanse må registreres inn av rederi. Eksempel på tilleggskompetanse kan være:<br></br>' +
      ' • Fartstid i polare farvann<br></br>' +
      ' • Seks måneder fartstid tilknyttet brovakttjeneste (til utstedelse av dekksoffisersertifikat)<br></br>' +
      ' • Seks måneder fartstid tilknyttet maskinvakttjeneste (til utstedelse av maskinoffisersertifikat)<br></br>',
    'competence.subheader.sideinfobox': 'Mangler tilleggskompetanse?',
    'competence.description.sideinfobox':
      'Ved mangler eller feil ber vi deg ta kontakt med de som har innrapportert tilleggskompetansen.<br></br>' +
      'Du kan ikke innrapportere egen tilleggskompetanse.',
    'competence.notfound': 'Ingen tilleggskompetanse ble funnet',
    'competence.table.subheader1': 'Fartøy',
    'competence.table.subheader2': 'Periode',
    'competence.table.subheader3': 'Tilleggskompetanse',
    'competence.table.subheader4': 'Kompetansekode',
    'competence.table.health.healthcheck': 'Helseattest',
    'competence.table.health.validTo': 'Gyldig til',
    'competence.table.health.colorVisionDate': 'Siste sjekk av fargesyn',
    'competence.table.health.decision.Fit': 'Gyldig, uten begrensninger',
    'competence.table.health.decision.FitLimited': 'Gyldig, med begrensninger',
    'competence.table.health.limitations': 'Begrensninger',
    'common.table.vessel': 'Fartøy',
    'common.table.periode': 'Periode',
    'assessment.header.description':
      'Det er kun godkjente assessorer som kan rapportere inn bedømmelser.<br></br>' +
      'Bedømmelser kan rapporteres inn av assessor på denne siden {link}',
    'assessment.subheader.sideinfobox': 'Mangler bedømmelse?',
    'assessment.description.sideinfobox':
      'Ved mangler eller feil ber vi deg ta kontakt med den som har utført bedømmelsen.',
    'assessment.notfound': 'Ingen bedømmelse ble funnet',
    'assessment.table.subheader1': 'Dato',
    'assessment.table.subheader2': 'Ansvarlig',
    'assessment.table.subheader3': 'Bedømmelse',
    'assessment.table.error': 'Kunne ikke hente bedømmelser',
    'health.subComponent.without.limitation': 'Egnet uten begrensning',
    'health.subComponent.with.limitation': 'Egnet med begrensning',
    'health.subComponent.valid': 'Gyldig tom.',
    'health.subComponent.fit.for.bridgeguard': 'Ikke skikket for utkikk',
    'health.subComponent.fit.for.security': 'Ikke skikket for sikkerhetsfunksjon',
    'health.subComponent.fit.for.other': 'Ikke skikket for annet arbeid ombord',
    'health.no.found': 'Kunne ikke hente helsesjekk.',
    'health.error': 'En feil oppstod som hindret henting av helsesjekk.',
    'vessel.preview.errors.missingvesselid': 'Mangler identifikasjons nummer for oppslag',
    'application.error.getown.list': 'Kunne ikke hente søknader.',
    'application.error.getown': 'Kunne ikke hente søknad.',
    'application.warning.title.timeoutExpired': 'Frist utgått',
    'application.warning.description.timeoutExpired':
      'Frist for å sende inn tilleggsinformasjon er utgått.',
    'application.info.heading':
      'Skal du sende inn tilleggsopplysninger til en påbegynt søknad, men finner ikke søknaden din?',
    'application.info.description': 'Da kan det være at søknaden er sendt inn via Altinn: ',
    'application.info.link':
      'Altinn - Send inn supplerende dokumentasjon til søknad om personlig sertifikat',
    'application.tile.status.Setup': 'Søknad påbegynt',
    'application.tile.status.AwaitingPayment': 'Søknad venter på betaling',
    'application.tile.status.Processing': 'Søknad levert til saksbehandler',
    'application.tile.status.MoreInfoRequested': 'Søknad mangler dokumentasjon',
    'application.tile.status.Approved': 'Søknad godkjent',
    'application.tile.status.Rejected': 'Søknad avslått',
    'application.tile.status.RejectedNotPaid': 'Søknad avsluttet pga manglende betaling',
    'application.tile.status.Processed': 'Søknadsprosess fullført',
    'application.tile.application.date.submission': 'Søknadsdato',
    'application.tile.application.date.created': 'Sist lagret',
    'application.tile.application.date.timeout': 'Frist for å laste opp manglende dokumentasjon',
    'application.tile.application.lettertext':
      'Hvis du har reservert deg mot digital kommunikasjon vi digital postkasse vil du ikke kunne motta vedtaksbrevet pr nå.  Vi arbeider med å få på plass manuell utsending.',
    'application.upload.missing.documentation': 'Last opp manglende dokumentasjon',
    'application.upload.missing.documentation.confirm':
      'Bekreft at manglende dokumentasjon er lastet opp',
    'application.upload.missing.documentation.go.back': 'Tilbake til søknad',
    'application.upload.missing.documentation.title.access': 'Ikke tillatt',
    'application.upload.missing.documentation.error.access':
      'Søknaden kan ikke endres nå. Dette kan skyldes at den er under saksbehandling eller at den allerede er godkjent/avslått.',
    'application.missing.documentation': 'Manglende dokumentasjon',
    'application.select.qualification.title': 'Velg manglende kvalifikasjon å laste opp',
    'application.delete.confirmation.title': 'Er du sikker på at du ønsker å slette søknad?',
    'application.delete.confirmation.error': 'Kunne ikke slette søknad',
    'application.lostsid.title': 'Meld tapt/mistet',
    'application.lostsid.description':
      'Er du sikker på at du vil melde dette Sjøfartskort som tapt?',
    'application.lostsid.reason': 'Begrunnelse',
    'sailor': 'Sjømann',
    'go.to.payment.button': 'Gå til betaling',
    'go.to.paymentStep.button': 'Gå til betalingssteg',
    'go.to.paymentSoltuion.button': 'Gå til betalingsløsningen',
    'download.paymentreceipt.button': 'Last ned kvittering',
    'physical.certificate': 'Fysisk sertifikat',
    'physical.certificate.tooltip':
      'Hvis du arbeider på NOR/NIS fartøy i norsk farvann så godkjenner Sjøfartsdirektoratet elektronisk sertifikat om bord. Hvis du skal seile på utenlandsk flagget fartøy eller utenfor norsk farvann så må du ha fysisk sertifikat om bord. Du kan bestille fysisk sertifikat senere ved behov.',
    'physical.certificate.required': 'Trenger fysisk sertifikat',
    'physical.certificate.notrequired': 'Trenger ikke fysisk sertifikat',
    'physical.certificate.modal.shipmentaddress.error': 'Kunne ikke laste opp Leveringsadresse',
    'app.addfiles.back': 'Tilbake til manglende dokumentasjon liste',
    'app.addfiles.types.application': 'Søknad',
    'app.addfiles.types.seagoing': 'Fartstid',
    'app.addfiles.types.course': 'Kurs',
    'app.addfiles.types.education': 'Utdanning',
    'app.addfiles.types.photo': 'Bilde',
    'app.addfiles.types.signature': 'Signatur',
    'app.addfiles.types.na': 'Annet',
    'app.addfiles.types.photocropped': 'Beskåret bilde',
    'app.addfiles.types.signaturecropped': 'Beskåret signatur',
    'app.addfiles.types.Assessment': 'Bedømmelse',
    'app.addfiles.types.AdditionalCompetence': 'Tilleggskompetanse',
    'app.addfiles.types.HealthCheck': 'Helse sjekk',
    'app.addfiles.types.Certificate': 'Sertifikat',
    'app.addfiles.types.ForeignCourse': 'Utenlandsk kurs',
    'app.addfiles.types.ForeignId': 'Gyldig id',
    'app.addfiles.types.NorwegianPassportOrId': 'Gyldig id',
    'app.addfiles.types.Letter': 'Brev',
    'app.addfiles.types.IssuedCertificate': 'Utstedt sertifikat',
    'app.addfiles.types.Confirmation': 'Bekreftelse',
    'app.addfiles.types.OverRule': 'Overprøve',
    'app.addfiles.input.type.label': 'Velg type vedlegg',
    'app.manual.drop.file': 'Slipp filer for å starte opplasting',
    'app.requirements.table.type': 'Type',
    'app.requirements.table.requirement': 'Krav',
    'app.requirements.table.upload': 'Last opp',
    'app.requirements.type.application': 'Søknad',
    'app.requirements.obligatoryreqsfor': 'Obligatoriske krav for {certificate}',
    'app.requirements.hidecompleted': 'Skjul beståtte',
    'app.requirements.showall': 'Vis alle',
    'app.requirements.title': 'Kravliste',
    'app.requirements.table.applicationrequirement': 'Application for {certificate}',
    'app.requirements.table.title': 'Last opp manglende kvalifikasjoner',
    'app.requirements.table.header': 'Last opp manglende kvalifikasjoner',
    'app.requirements.uploadotherdocuments': 'Last opp andre dokumenter',
    'app.requirements.status.pending': 'Avventer',
    'app.requirements.status.missing': 'Mangler',
    'app.requirements.status.valid': 'Gyldig',
    'app.requirements.status.expired': 'Utgått',
    'app.requirements.group.basis': 'Basis',
    'app.requirements.group.alternative': 'Alternativ\xa0{number}',
    'app.requirements.group.additional': 'Tillegg',
    'app.requirements.missing.error.title': 'Mangler dokumentasjon',
    'app.requirements.missing.error.desc': 'Et eller flere av kravene må dokumenteres',
    'app.requirements.state.update.error': 'Kunne ikke bekrefte opplasting av dokumentasjon',
    'app.requirements.type.seagoing': 'Fartstid',
    'app.requirements.type.course': 'Kurs',
    'app.requirements.type.education': 'Utdanning',
    'app.requirements.type.certificate': 'Sertifikat',
    'app.requirements.type.health': 'Helseerklæring',
    'app.requirements.type.assessment': 'Evaluering',
    'app.requirements.type.additionalcompetence': 'Tilleggskompetanse',
    'app.requirements.type.confirmation': 'Bekreftelse',
    'app.requirements.type.declaration': 'Erklæring',
    'app.requirements.type.idcard': 'ID-kort',
    'app.requirements.type.profilepicture': 'Profilbilde',
    'app.requirements.type.signature': 'Signatur',
    'app.requirements.type.foreignid': 'Gyldig id',
    'app.requirements.type.other': 'Annet',
    'app.requirements.errors.missingfiledata': 'Ufullstendig data for fil: {filename}',
    'app.requirements.additionalcompetence.select.placeholder': 'Velg tilleggskompetanse',
    'app.organization.search': 'Søk etter organisasjon',
    'app.organization.addmanualemployer': 'Legg til organisasjon manuelt',
    'app.organization.searchemployer': 'Søk etter organisasjon',
    'app.organization.newOrganization.name': 'Foretaksnavn *',
    'app.organization.newOrganization.type': 'Selskapsform',
    'app.organization.newOrganization.organizationNumber': 'Organisasjonsnummer eller tilsvarende',
    'app.customerCard.dNumber': 'Fødselsnummer/D-nummer',
    'app.additional.competence.completion.date': 'Fullført',
    'app.additional.competence.from.date': 'Fra dato',
    'app.additional.competence.to.date': 'Til dato',
    'app.details.addcompetence.competence': 'Tilleggskompetanse',
    'app.details.addcompetence.organization': 'Organisasjon',
    'app.requirements.errors.attachmentmissing': 'Vedlegg mangler',
    'certreq.requirements.title': 'Krav for sertifikatet',
    'certreq.requirements.intro':
      'Her ser du kravene for sertifikatet du søker om, og hvordan de er vurdert mot opplysningene Sjøfartsdirektoratet har om deg. Mangler vi dokumentasjon, kan du laste den opp under det aktuelle kravet.',
    'certreq.requirements.empty': 'Vi fikk ikke noe kravtre for dette sertifikatet.',
    'certreq.requirement.untitled': 'Krav uten navn',
    'certreq.status.pass': 'Oppfylt',
    'certreq.status.fail': 'Ikke oppfylt',
    'certreq.status.inconclusive': 'Kan ikke vurderes automatisk',
    'certreq.overall.pass': 'Alle krav er oppfylt',
    'certreq.overall.fail': 'Noen krav er ikke oppfylt',
    'certreq.overall.inconclusive': 'Noen krav kan ikke vurderes automatisk',
    'certreq.evaluationdate': 'Vurdert per {date}',
    'certreq.branch.allof': 'Alle av disse',
    'certreq.branch.anyof': 'Én av disse veiene',
    'certreq.branch.oneof': 'Nøyaktig én av disse',
    'certreq.branch.not': 'Ingen av disse',
    'certreq.reason': 'Begrunnelse',
    'certreq.usedservices': 'Brukt fartstid',
    'certreq.usedservices.item': 'oppføring {index} ({days} dager)',
    'certreq.upload.title': 'Dokumentasjon',
    'certreq.upload.button': 'Last opp fil',
    'certreq.upload.missingkey':
      'Dette kravet mangler en kravidentifikator, og kan derfor ikke ta imot dokumentasjon her. Ta kontakt med Sjøfartsdirektoratet.',
    'certreq.upload.error.title': 'Filen ble ikke lagret',
    'certreq.documented.label': 'Dokumentert',
    'certreq.documented.hint':
      'Dokumentasjonen du har lastet opp sendes til saksbehandler, og endrer ikke den automatiske vurderingen over.',
    'certreq.error.forbidden.title': 'Du mangler tilgang',
    'certreq.error.forbidden.desc':
      'Du har ikke rettigheter til å hente kravene for dette sertifikatet. Prøv igjen senere, eller ta kontakt med Sjøfartsdirektoratet.',
    'certreq.error.gateway.title': 'Kravene kunne ikke hentes',
    'certreq.error.gateway.desc': 'Tjenesten svarte ikke. Prøv igjen om litt.',
    'certreq.error.unknown.title': 'Kravene kunne ikke hentes',
    'certreq.error.unknown.desc': 'Noe gikk galt da vi hentet kravene. Prøv igjen.',
    'certreq.requirementtype.education': 'Utdanning',
    'certreq.requirementtype.course': 'Kurs',
    'certreq.requirementtype.onboardtraining': 'Opplæring om bord',
    'certreq.requirementtype.assessment': 'Bedømmelse',
    'certreq.requirementtype.competency': 'Tilleggskompetanse',
    'certreq.requirementtype.confirmation': 'Bekreftelse',
    'certreq.requirementtype.declaration': 'Erklæring',
    'certreq.requirementtype.certificate': 'Sertifikat',
    'certreq.requirementtype.seagoingservice': 'Fartstid',
    'certreq.requirementtype.age': 'Alder',
    'certreq.requirementtype.healthcertificate': 'Helseerklæring',
    'certreq.requirementtype.healthcertificaterecreational': 'Helseerklæring for fritidsskipper',
    'certreq.requirementtype.health': 'Helse',
    'certreq.requirementtype.yearssincecompletion': 'År siden fullført',
    'certreq.requirementtype.dateofcompletion': 'Fullføringsdato',
    'certreq.requirementtype.idcard': 'Legitimasjon',
    'certreq.requirementtype.profilepicture': 'Profilbilde',
    'certreq.requirementtype.signature': 'Signatur',
    'certreq.userview.heading': 'For å søke {certificateName} må du oppfylle disse kravene',
    'certreq.userview.loading': 'Vi henter kravene for sertifikatet. Vent litt.',
    'certreq.userview.status.fulfilled': 'Oppfylt',
    'certreq.userview.status.uploaded': 'Dokumentert',
    'certreq.userview.status.missing': 'Mangler',
    'certreq.userview.status.notapplicable': 'Ikke aktuelt',
    'certreq.userview.alternatives.heading': 'I tillegg må ett av disse alternativene oppfylles',
    'certreq.userview.atleastoneof': 'Minst ett av',
    'certreq.userview.exactlyoneof': 'Nøyaktig ett av',
    'certreq.userview.grouplogic.allof': 'Alle disse',
    'certreq.userview.grouplogic.atleastoneof': 'Minst ett av disse',
    'certreq.userview.grouplogic.exactlyoneof': 'Nøyaktig ett av disse',
    'certreq.userview.upload': 'Last opp dokumentasjon',
    'certreq.userview.addfile': 'Legg til fil',
    'certreq.userview.uploadfor': 'Last opp dokumentasjon for {title}',
    'certreq.userview.uploadedfilesfor': 'Vedlagte filer for {title}',
    'certreq.userview.removefile': 'Fjern {fileName}',
    'certreq.userview.declaration.confirm': 'Jeg bekrefter ovenstående',
    'certreq.userview.declaration.confirmfor': 'Jeg bekrefter: {title}',
    'certreq.userview.declaration.locked': 'Søknaden er sendt inn, og erklæringen kan ikke endres.',
    'certreq.userview.declaration.error':
      'Erklæringen ble ikke lagret. Prøv igjen, eller last siden på nytt.',
    'certreq.userview.declaration.missingkey':
      'Dette kravet mangler en kravidentifikator, og erklæringen kan derfor ikke lagres her. Ta kontakt med Sjøfartsdirektoratet.',
    'certreq.userview.declaration.required':
      'Du må bekrefte erklæringene som kreves før du kan gå videre. Der det finnes alternativer, holder det å bekrefte erklæringene i ett av dem.',
    'certreq.userview.declaration.unknown':
      'Vi fikk ikke hentet kravene for sertifikatet, og vet derfor ikke om du må bekrefte en erklæring før du går videre.',
    'certreq.userview.expandgroup': 'Vis kravene under {title}',
    'certreq.userview.collapsegroup': 'Skjul kravene under {title}',
    'certreq.userview.yourpath': 'Din vei',
    'certreq.userview.showother': 'Vis andre alternativer',
    'certreq.userview.hideother': 'Skjul andre alternativer',
    'certreq.userview.untitled': 'Krav',
    'certreq.userview.alternativefallback': 'Alternativ {number}',
    'certreq.userview.norequirements': 'Sertifikatet har ingen krav å vise.',
  },
  en: {
    ...utilMessages.en,
    ...fileCropMessages.en,
    ...vesselPreviewMessages.en,
    ...certificateCardMessages.en,
    ...healthMessages.en,
    ...seagoingMessages.en,
    ...generalMessages.en,
    'language': 'English',
    'userbar.logout': 'Log out',
    'userbar.loggedin': 'Logged in',
    'userbar.as': 'as',
    'userbar.idporten': 'You are logged in to all public services using ID-porten',
    'userbar.otherUser': 'You are logged in as ',
    'userbar.otherUser.info':
      'in the Norwegian Maritime Directorate´s systems with ID-porten — and thus have access to several applications. If you log out from here, you will also be logged out of these.',
    'userbar.sdirlink': 'Go to Sjøfartsdirektoratet (sdir.no)',
    'userbar.menu': 'Menu',
    'userbar.skiplink': 'Skip to main content',
    'footer.tagline': '- The preferred maritime administration',
    'footer.about.title': 'About sdir.no',
    'footer.about.privacy': 'Privacy Policy',
    'footer.about.accessibility': 'Accessibility statement',
    'footer.social.title': 'Follow us',
    'footer.social.facebook': 'Visit us on Facebook',
    'footer.social.instagram': 'Visit us on Instagram',
    'footer.social.linkedin': 'Visit us on LinkedIn',
    'login.org.error':
      'You need to log in as a person to see your qualifications. You are now logged in as an organization.',
    'general.form.error': 'Required field',
    'general.form.error.invalidnumberformat': 'Not a valid number format',
    'general.form.error.datemustbeinthepast': 'Date must be in the past',
    'general.form.error.startdatemustbebeforeenddate': 'Start date must be before end date.',
    'general.form.error.phone': 'Phone number must contain only numbers.',
    'general.form.error.phone.length': 'Phone number must contain at least 6 characters.',
    'general.form.error.phone.maxlength': 'Phone number can contain maximum 14 characters.',
    'general.form.error.postNr': 'Zip code can only contain numbers.',
    'general.form.error.email': 'Enter a valid email.',
    'general.form.cancel': 'Cancel',
    'general.form.close': 'Close',
    'general.form.save': 'Save',
    'general.form.yes': 'Yes',
    'general.form.delete': 'Delete',
    'general.form.submit': 'Submit',
    'general.form.next': 'Next',
    'general.form.goback': 'Back',
    'general.form.back': 'Back to certificate overview',
    'general.form.deletedocument': 'Delete document',
    'general.form.dropfile': 'Drop files to start uploading',
    'general.gender.F': 'Female',
    'general.gender.M': 'Male',
    'general.error.title': 'Error',
    'general.error.failedtoload': 'Failed to load data',
    'general.error.failedtoloadattachment': 'Failed to load attachment',
    'general.error.failedtouploadattachment': 'Failed to upload attachment',
    'general.error.invalidstateforroute': 'Invalid app state for given route.',
    'general.error.unknownerror': 'Unknown error.',
    'general.error.buildsubmitsequence': 'Planning submissions',
    'general.error.no.results': 'No results',
    'general.inputs.country.required': 'Country',
    'general.search.error': 'Could not complete search.',
    'general.search.nomatches': 'No hits',
    'general.search.minimumchars': 'Enter at least 3 characters to search',
    'general.button.close': 'Close',
    'general.button.save': 'Save',
    'general.button.edit': 'Edit',
    'general.button.send': 'Send',
    'general.button.approve': 'Approve',
    'general.button.reject': 'Reject',
    'general.button.confirmDelete': 'Confirm delete',
    'general.button.downloadpdf': 'Download PDF',
    'general.table.viewdetails': 'View details',
    'general.table.showdetails': 'Show details',
    'general.table.hidedetails': 'Hide details',
    'general.table.total': 'Total:',
    'general.table.expired': 'Expired ',
    'general.button.delete.application': 'Delete application',
    'general.button.open.application': 'Open application',
    'general.button.open': 'Open',
    'general.button.retry': 'Retry',
    'general.separator.and': ' and ',
    'general.no': 'No',
    'general.yes': 'Yes',
    'submitsteps.success': 'Completed successfully',
    'submitsteps.skipped': 'Skipped due to failed earlier step',
    'submitsteps.fileupload': 'Upload file {filename}',
    'submitsteps.fileremoval': 'Remove existing file {filename}',
    'submitsteps.prevalidateseagoing': 'Validate seagoing time',
    'submitsteps.newseagoing': 'Submit new seagoing time',
    'submitsteps.updatedseagoing': 'Update existing seagoing time',
    'submitsteps.deletedseagoing': 'Delete removed seagoing time',
    'submitsteps.prevalidatecourse': 'Validate course participation',
    'submitsteps.submitcourse': 'Submitting course participation',
    'submitsteps.requestfailed': 'Request failed',
    'submitsteps.errors.submitabortedtryagain':
      'Error encountered for one or more submissions. Try to make corrections, then try resubmitting.',
    'applicationsOverview.page.title': 'My certificate applications',
    'certificateDashboard.page.title': 'My certificates and endorsements',
    'certificateDashboard.page.description':
      'Here you can see all your approved maritime certificates and endorsements. You can also apply for new ones.',
    'competenceDashboard.educatia.title': 'Exam',
    'competenceDashboard.educatia.registered': 'You have an approved exam registered',
    'competenceDashboard.educatia.created': 'Open new exam',
    'competenceDashboard.educatia.current': 'Open ongoing SRC exam',
    'competenceDashboard.educatia.new': 'Take SRC exam',
    'competenceDashboard.page.title': 'My competences',
    'competenceDashboard.page.description':
      'Here you can see your health certificate, registered seagoing time and completed courses.',
    'sidDashboard.page.title': 'Seafarer´s identity card',
    'sidDashboard.page.description':
      'Here you can see your approved seafarer identity cards. You can also apply for new ones.',
    'sidOverview.button.newapplication': 'New seafarer´s identity card application',
    'sidCreate.info.duplicate.title': 'Duplicate of seafarer´s identity card',
    'sidCreate.info.duplicate.text1':
      'Before you can apply for a duplicate seafarer´s identity card, your current card must be reported lost/missing.',
    'sidCreate.info.duplicate.text2': 'You do this by:',
    'sidCreate.info.duplicate.text3':
      '1. Go to the application for the seafarer´s identity card that has already been approved',
    'sidCreate.info.duplicate.text4': '2. Select <b>Report lost/missing</b> on the card',
    'sidCreate.info.duplicate.text5':
      'Once the card has been registered as lost/missing, you can proceed and submit an application for a duplicate.',
    'root.page.title': 'Your maritime services',
    'home.page.title': 'My side sailors',
    'home.info.digitalcertificate':
      'The Norwegian Maritime Authority now only issues electronic certificates, where a photo and signature are not required. See more info at sdir.no',
    'home.info.paymentproblems':
      'Applications submitted between 19-21 May - which have the status "waiting for payment" on my page seafarers, must be paid again in order to be processed - this is due to a system error that has now been corrected. The payment that has already been deducted from your account will be refunded - this may take up to 5 business days before this appears on your account.',
    'home.tile.certificate': 'Certificates',
    'home.tile.endorsement': 'Endorsements',
    'home.tile.seagoingtime': 'Seagoing Time',
    'home.tile.courseAndEducation': 'Course & education',
    'home.tile.competence': 'Additional competence',
    'home.tile.assessment': 'Assessment',
    'home.tile.paymentSolution': 'Payments overview',
    'home.tile.myprofile': 'My profile',
    'missingdocumentation.page.confirmmodal.receivedtitle': 'Additional information received',
    'missingdocumentation.page.confirmmodal.receivedinfo':
      'Additional information is received and saved!',
    'missingdocumentation.page.base.allok': 'All requirements are fulfilled',
    'missingdocumentation.page.base.allok.cert': 'All requirements to {certificate} are fulfilled',
    'missingdocumentation.page.base.title': 'The following requirements needs to be documented',
    'missingdocumentation.page.base.title2': 'The following requirements are now documented',
    'missingdocumentation.page.base.title3': 'The following requirements are fulfilled',
    'missingdocumentation.page.alternative.title':
      'You may also document <b>one</b> of the following alternatives',
    'missingdocumentation.page.alternative.title2':
      'You may document <b>one</b> of the following alternatives',
    'missingdocumentation.page.alternative.titlefulfilled':
      'You have now documented these alternatives',
    'missingdocumentation.page.togglealternatives': 'Show all alternatives',
    'missingdocumentation.page.togglealternatives2': 'Reset displayed alternatives',
    'endorsements.page.title': 'Endorsements',
    'endorsements.page.subtitle1': 'My endorsements',
    'endorsements.page.endorsement': 'Endorsement',
    'endorsements.page.dispensation': 'Dispensation',
    'endorsements.page.name': 'Endorsement',
    'endorsements.page.issued': 'Issued at',
    'endorsements.page.limitation': 'In accordance with national certification',
    'endorsements.page.minrequirements':
      'This certificate is issued in accordance with the International Convention on Standards of Training, Certification, and Watchkeeping for Seafarers, 1978, as amended.',
    'endorsements.noendorsements': 'You have no endorsements',
    'applications.table.showcompleted': 'Show completed applications',
    'applications.table.hidecompleted': 'Hide completed applications',
    'certificates.page.title': 'Certificates and endorsements',
    'certificates.label.expired': 'Expired',
    'certificates.label.daysleft': 'days left',
    'certificates.button.showcertificate': 'Show certificate',
    'certificates.button.receipt': 'Receipt',
    'certificates.button.showapplication': 'Open application',
    'certificates.button.reportlost': 'Report lost/missing',
    'certificates.button.newapplication': 'New certificate application',
    'certificates.button.myapplications': 'My applications',
    'certificates.button.myapplications.info': 'View applications and receipt',
    'certificates.empty.title': 'No certificates found!',
    'certificates.requestmoreinfo.title': 'We need additional information!',
    'certificates.requestmoreinfo.description':
      'In applying for <b>{certificate}</b> we need more information.',
    'certificates.requestmoreinfo.button': 'Add more information',
    'certificates.table.showexpired': 'Show expired certificates',
    'certificates.table.hideexpired': 'Hide expired certificates',
    'certificates.table.status.valid': 'Valid',
    'certificates.table.status.invalid': 'Invalid',
    'certificates.table.label.activeapplications': 'Active applications',
    'certificates.table.label.application': 'Application',
    'certificates.table.label.certificate': 'Certificate',
    'certificates.table.label.dispensation': 'Dispensation',
    'certificates.table.label.validto': 'Valid to',
    'certificates.table.label.expiry': 'Expires',
    'certificates.table.label.status': 'Status',
    'certificates.table.label.created': 'Last saved',
    'certificates.table.label.issued': 'Issued date',
    'certificates.table.label.documentnumber': 'Document number',
    'certificates.alert.title': 'Important information',
    'certificates.alert.subtitle': 'Creating an application and submitting additional information',
    'certificates.alert.description':
      'Due to the transition to a new IT system, it is currently not possible to create applications or submit additional information. We are working to improve our services, and the functions will be available again from Monday. We apologize for any inconvenience this may cause and thank you for your understanding.',
    'certificates.page.subtitle': 'My applications',
    'certificates.page.subtitle2': 'My certificates',
    'certificates.page.subtitle3': 'Expired certificates',
    'certificates.page.approvedFilter': 'Show approved',
    'certificates.page.newApp': 'Start new application',
    'certificates.errors.unabletoloadcertificates': 'Unable to load certificates',
    'certificates.novalidcertificates': 'You have no valid certificates',
    'certificates.noinvalidcertificates': 'You have no expired certificates',
    'certificatetile.expirydate': 'Expiry date',
    'certificatetile.validfromdate': 'Valid from',
    'certificatetile.status.valid': 'Valid',
    'certificatetile.status.expired': 'Expired',
    'certificatetile.status.cancelled': 'Cancelled',
    'certificatetile.status.inactive': 'Inactive',
    'certificate.app.type': 'Application type',
    'certificate.page.title': 'Certificate',
    'app.type.duplicate': 'Duplicate',
    'app.type.firstTime': 'First time',
    'app.type.renewal': 'Renewal',
    'app.type.upgrade': 'Upgrade',
    'filegroup.chosenfile': 'Selected file',
    'filegroup.deletefile': 'Delete file',
    'filegroup.addfiles': 'Upload additional files',
    'newapp.steps.certificate': 'Certificate type',
    'newapp.steps.qualifications': 'Qualifications',
    'newapp.steps.contactinfo': 'Contact info',
    'newapp.steps.photoandsignature': 'Photo and signature',
    'newapp.steps.summary': 'Summary',
    'newapp.steps.payment': 'Payment',
    'newapp.steps.payment.complete': 'Go to summary',
    'newapp.steps.payment.no.charges': 'Could not find any charges',
    'newapp.steps.payment.failed': 'Could not complete payment',
    'newapp.steps.payment.failed.charges':
      'Creation of the fee takes longer than planned. Please try to refresh the page in a little while.',
    'newapp.steps.payment.loadingmessage': 'This may take some time. Please wait.',
    'newapp.steps.payment.paid':
      'Payemnt has already been made. Click the button below to go to application overview.',
    'newapp.steps.payment.go.to.application.details': 'Go to application overview',
    'select.certificate.title': 'Select certificate',
    'certificate.type': 'Certificate type',
    'certificate.type.renewal.title': 'Certificate renewal',
    'certificate.type.renewal.info':
      'You cannot apply for renewal before the original certificate has less than 6 months to expire. Applications for renewal can only be made when the certificate is approaching expiration.',
    'select.certificate.h1': 'New certificate:',
    'qualification.descriptionBox.heading': 'Mandatory Qualifications',
    'qualification.descriptionBox.steplabel': 'Step {current} of {total}',
    'qualification.descriptionBox.contents':
      'To have this certificate issued you must fullfill the mandatory qualifications in step 1.<linebreak></linebreak>' +
      'You must also fullfill one of the alternatives in step 2.<linebreak></linebreak>' +
      'For qualifications not registered in out systems you can attach documentation to the application. ' +
      'Please not that the application will then need to go through manual processing.',
    'qualification.description.heading': 'Description',
    'qualification.tile.seagoing': 'Seagoing Time',
    'qualification.tile.education': 'Education',
    'qualification.tile.competence': 'Competence',
    'qualification.tile.health': 'Health declaration',
    'qualification.doc.edit': 'Edit documents',
    'qualification.doc.upload': 'Upload documents',
    'qualification.confirm': 'I confirm the above',
    'qualification.course.upload': 'Upload course diploma',
    'qualification.signature.valid': 'Signature is documented',
    'qualification.signature.required': 'Signature needs to be documented',
    'qualification.photo.valid': 'Photo is documented',
    'qualification.photo.required': 'Photo needs to be documented',
    'qualification.overrule.title':
      'Do you have the necessary skills that meet the requirements for the certificate, but the system disagrees with you?',
    'qualification.overrule.comment': 'Comment',
    'qualification.overrule.toggle': 'I would still like a case manager to look at my application',
    'qualification.certificatecheck.title':
      'I confirm that I have the right to drive a recreational vessel requiring a boatmans licence, ' +
      'and am aware that it may be a criminal offense to provide incorrect information.',
    'qualification.certificatecheck.tooltip':
      'Recreational craft requiring a boat operators license means recreational boats (incl. jet skis) with ' +
      'length over 8 meters or which has an engine with a greater output than 25 HP. Boat drivers certificate, ' +
      'Norwegian ICC, or higher certificates (D5L/A, D6-D1) give the right to operate such vessels. ' +
      'Other certificates/evidence can also give such a right, contact post@sdir.no in the case of such ' +
      'instances. Persons born before 1.1.1980 are automatically entitled to carry ' +
      'recreational vessel requiring a boat operators license without any kind of certificate/certificate.',
    'qualification.certificatecheck.error': 'You must confirm to proceed',
    'qualification.errors.infoincomplete': 'Incomplete registration of documentation',
    'qualification.errors.uploaddoctocontinue':
      'You need to upload missing documentation before you can continue',
    'qualification.errors.requirementnotmet':
      'You do not meet the requirements to continue to the next step',
    'additionalqualifications.infobox.heading': 'Additional qualifications',
    'additionalqualifications.alternative': 'Alternative {number}',
    'addcourse.organizations': 'Educational institution',
    'addcourse.education': 'Education',
    'addcourse.date': 'Completed/issued',
    'addcourse.foreignCourse': 'Foreign course',
    'addcourse.education.title': 'Upload diploma',
    'addcourse.get.course.error': 'Could not get Educational institutions',
    'addcourse.searchcourses': 'Search courses ',
    'addcourse.nomatchingcourse':
      'The course is not available at the selected educational institution',
    'addcourse.changeforeigncourse.title': 'Change foreign course',
    'addcourse.changeforeigncourse':
      'When changing to/from foreign course, you will need to delete all documents and add them again. Please do this before you continue.',
    'addseagoing.title': 'Seagoing time',
    'addseagoing.upload.previous': 'Select previously uploaded file',
    'addseagoing.upload.new': 'Upload new documentation',
    'addseagoing.button.new': 'New seagoing time',
    'addseagoing.apply.for':
      'To apply for {cert} you have to provide documentation for the following:',
    'addseagoing.fetch.error': 'Could not fetch seagoing time.',
    'addseagoing.save.error.toobig': 'The file is too large to be uploaded.',
    'addseagoing.relevant.heading': 'Seagoing time added to the application that needs approval',
    'addseagoing.notrelevant.heading':
      'Seagoing time added to the application that does not meet the requirement',
    'addseagoing.approved.heading':
      'Previously approved seagoing time that does meet the requirement',
    'addseagoing.approvedunused.heading':
      'Previously approved seagoing time that does not meet the requirement',
    'addseagoing.confirm.heading': 'Incomplete documentation',
    'addseagoing.confirm.description':
      'You are missing <b>{days}</b> days of seagoing time documentation. Do you wish to continue without complete documentation for seagoing time?',
    'addseagoing.heading': 'Uploading seagoing time',
    'addseagoing.description': 'Add seagoing data from attachment',
    'addseagoing.employer': 'Employer',
    'addseagoing.vessel': 'Vessel',
    'addseagoing.table.jobTitle': 'Job title',
    'addseagoing.table.periodStart': 'Period start',
    'addseagoing.table.periodEnd': 'Period end',
    'addseagoing.table.hours': 'Hours per day',
    'addseagoing.table.attachments': 'Vedlegg',
    'addseagoing.vessel.vesselsearch': 'Search for name, imo, callsign ...',
    'addseagoing.vessel.addmanualvessel': 'Add vessel manually',
    'addseagoing.vessel.searchvessel': 'Search for NIS/NOR vessel',
    'addseagoing.vessel.newVessel.registry': 'Registry',
    'addseagoing.details.jobtitle': 'Select occupation',
    'addseagoing.details.periodstart': 'Period start',
    'addseagoing.details.periodend': 'Period end',
    'addseagoing.details.totalhours': 'Total number of hours in period',
    'addseagoing.details.hoursperday': 'Number of hours per day',
    'addseagoing.details.sethoursperday': 'Provide hours per day',
    'addseagoing.details.settotalhours': 'Provide total number of hours',
    'addseagoing.details.hourstooltip':
      'You may provide the seagoing time as number of work hours total for the given period. ' +
      'Alternatively, you may provide number of hours per work day, and the system will ' +
      'calculate the total for you, based on the given period.',
    'addseagoing.details.add': 'Add seagoing time',
    'addseagoing.details.mustaddone': 'Must add at least one seagoing time registration',
    'addseagoing.addmoreseagoingtime': 'Add more seagoing time',
    'addseagoing.errors.noseagoingtimeadded': 'No seagoing time added',
    'addseagoing.button.edit': 'Edit vessel',
    'addseagoing.missingdays':
      '<i>{requirement} <b>You are missing documentation on {days} days seagoing time</b></i>',
    'addseagoing.missingdays2':
      'You are missing documentation on <b>{days}</b> days seagoing time for the requirement "{requirement}"',
    'addseagoing.alldocumented':
      'You have documented all seagoing time you need for this requirement',
    'addseagoing.vessel.togglevessel': 'Show/hide vessel',
    'addseagoing.incomplete.tooltip':
      'If you believe your seagoing time meets the current requirements, it is still possible to submit the application. To do this, you must press the "next" button. You will then return to the application overview. Scroll all the way down the page and choose to have a case manager look at your application.',
    'addseagoing.incomplete.tooltip2':
      'If you believe your seagoing time meets the current requirements, it is still possible to submit the application. To do this, you must press the "ok" button. You will then return to the application overview. Scroll all the way down the page and choose to have a case manager look at your application.',
    'addassessment.assessor.title': 'Fill in information about assessor:',
    'addassessment.assessor.firstname': 'Assessor first name and middle name',
    'addassessment.assessor.lastname': 'Assessor last name',
    'addassessment.assessor.personalidentitynumber': 'Assessor Personal Identification Number',
    'addassessment.assessor.invalidpersonnumber': 'Invalid d-/personal identification number',
    'addassessment.assessor.search': 'Person search',
    'addassessment.assessor.label': 'Assessor',
    'addassessment.restore': 'Restore assessment',
    'addassessment.periodstart': 'Period start',
    'addassessment.periodend': 'Period end',
    'addassessment.assessmentcode': 'Assessment',
    'addassessment.assessor.personnotfound': 'No match found',
    'addassessment.prevalidate': 'Validate assessment',
    'addassessment.submit': 'Submit assessment',
    'addassessment.submit.error': 'Could not update assessment',
    'addhealth.heading': 'Health Check',
    'addhealth.description': 'Add documentation for your health check here',
    'addcompetence.heading': 'Additional competence',
    'addcompetence.description': 'Add documentation for your additional competence here',
    'addPhoto.heading': 'Profile picture',
    'addPhoto.instruction1': 'The facial photo should show the holder´s face as they appear today',
    'addPhoto.instruction2':
      'The face should show the entire head and upper part of the shoulders and be taken from the front',
    'addPhoto.instruction3': 'Your gaze should be directed towards the camera lens',
    'addPhoto.instruction4': 'Both eyes, eyebrows and ears should be fully visible',
    'addPhoto.instruction5':
      'The facial expression should be neutral and the mouth should be closed',
    'addPhoto.instruction6':
      'The background should be white, and the face and background should be evenly lit',
    'addPhoto.instruction7':
      'Glasses and headgear should not be worn (certain exceptions for religious headgear)',
    'addPhoto.instruction7.tooltip':
      'For religious or other special reasons, such as illness, individuals may wear headgear in the photograph when it is expected that the person will wear similar headgear in future checks. The headgear must not cover any of the face or more of the head than is necessary. The headgear must not be so tight that it changes the natural shape of the face.',
    'addPhoto.instruction8':
      'Scarves, bags and outerwear must be removed before being photographed',
    'addPhoto.imageformat': 'Attachments must be uploaded in JPG or PNG format.',
    'addPhoto.filesize': 'The file is too large. The maximum file size is 10 MB.',
    'addPhoto.upload': 'Upload a new file',
    'addSignature.heading': 'Signature',
    'addSignature.image.error':
      'The image is too low resolution. The minimum size is 1000 × 200 pixels.',
    'addSignature.instruction1': 'Write the signature by hand on a white, unlined sheet of paper',
    'addSignature.instruction2':
      'It should resemble the name on your passport/ID and be easy to read',
    'addSignature.instruction3': 'Avoid large variations in the letters',
    'addSignature.instruction4': 'Use black pen',
    'addSignature.instruction5': 'The image of the signature must be of good quality',
    'addforeignid.heading': 'Valid id',
    'addforeignid.description': 'Add documentation for your valid id here',
    'addcertificate.heading': 'Certificate',
    'addcertificate.description': 'Add documentation for your certificate here',
    'addnorwegianid.heading': 'Valid id',
    'addassessment.heading': 'Assessment',
    'addassessment.description': 'Add documentation for your assessment here',
    'addconfirmation.heading': 'Confirmation',
    'addconfirmation.description': 'Add documentation for your confirmation here',
    'contactinfo.title': 'Contactinformation',
    'contactinfo.dialCode': 'Country code',
    'contactinfo.phone': 'Phone',
    'contactinfo.email': 'E-mail address',
    'contactinfo.gender': 'Gender',
    'contactinfo.differentaddress': 'Deliver certificate to another address',
    'contactinfo.address': 'Address',
    'contactinfo.navn': 'Name',
    'contactinfo.streetaddress': 'Street address',
    'contactinfo.streetaddress.optional': 'Street address (Optional)',
    'contactinfo.receiver': 'Receiver',
    'contactinfo.postnr': 'Zip code',
    'contactinfo.postlocation': 'Post office',
    'contactinfo.country': 'Country',
    'contactinfo.deliveryaddress': 'Delivery address',
    'contactinfo.noaddressfound':
      'Registered address is missing in the National Population Register.',
    'contactinfo.freginfo':
      'The address provided is taken from the Population Register. If the address is incorrect, it must be updated in the Population Register before the application can be processed.',
    'contactinfo.loading': 'Loading...',
    'contactinfo.error': 'Could not upload contact info',
    'photoandsignature.uploadphoto': 'Click to upload image',
    'photoandsignature.uploadnewphoto': 'Click to upload new image',
    'photoandsignature.uploadsignature': 'Click to upload signature',
    'photoandsignature.uploadnewsignature': 'Click to upload new signature',
    'photoandsignature.keepoldimages': 'Click next to keep your existing photo and signature',
    'photoandsignature.helptext':
      'Here you can adjust your image. You can see a preview of the result on the right. You zoom by scrolling with the mouse. If you need more tools, these are below the picture. Move the image so that it looks good in the selected area.',
    'photoandsignature.photo': 'Photo',
    'photoandsignature.signature': 'Signature',
    'photoandsignature.requirement.header': 'Requirement og rules for photo and signature',
    'photoandsignature.requirement.section.1.subheader': 'Existing photo and signature:',
    'photoandsignature.requirement.section.1.content':
      'If you already have a valid photo (of more recent date) or signature,' +
      'you do not need to upload a new one. If you have a photo of an older date, ' +
      'we recommend that you upload a new photo that meets the requirements listed below.',
    'photoandsignature.requirement.section.2.subheader': 'The picture:',
    'photoandsignature.requirement.section.2.content':
      '• It should be of a more recent date \n' +
      '• Make sure the background is white or neutral \n' +
      '• Only the head and shoulders should be included \n' +
      '• Look straight into the camera and make sure your face is evenly lit \n' +
      '• Both eyes, eyebrows and ears should be completely visible \n' +
      '• The face of the applicant must be pictured directly from the front \n' +
      '• The background should be evenly lit \n' +
      '• The face should be evenly lit \n',
    'photoandsignature.requirement.section.3.subheader': 'The signature:',
    'photoandsignature.requirement.section.3.content':
      '• The signature must be in black pen on a white background \n' +
      '• Make sure the background is white or neutral',
    'photoandsignature.steps.uploadnewphoto': 'Attach new photo',
    'photoandsignature.steps.uploadnewcroppedphoto': 'Attach new cropped photo',
    'photoandsignature.steps.uploadnewsignature': 'Attach new signature',
    'photoandsignature.steps.uploadnewcroppedsignature': 'Attach new cropped signature',
    'summarystep.confirmdraft': 'Prepare application for payment',
    'summarystep.yourqualifications': 'Your Qualifications',
    'summarystep.photoandsignature.addedphoto': 'New photo uploaded',
    'summarystep.photoandsignature.useexistingphoto': 'Existing photo is used',
    'summarystep.photoandsignature.addedsignature': 'New signature uploaded',
    'summarystep.photoandsignature.useexistingsignature': 'Existing signature is used',
    'summarystep.photoandsignature.nochanges': 'No changes',
    'summarystep.expirydate': 'The certificate will get this expiry date',
    'summarystep.expirydate.info': 'Show information about expiry date',
    'summarystep.expirydate.disagree.header': 'Why do I get a short expiry date?',
    'summarystep.expirydate.disagree.info':
      'Many certificates get an expiry date based on completed courses. If you have completed a new course, but this has not been registered by the course centre, this may explain the short expiry date. Ask the course center to register the course for you, or use overrule and upload the relevant course certificate.',
    'summarystep.expirydate.overrule':
      'I disagree with the expiry date and want a case manager to look at my application',
    'summarystep.expirydate.overrule.checklabel':
      'I disagree with the expiry date and want a case manager to review the expiry date for the certificate',
    'summarystep.charge': 'Charge',
    'summarystep.charge.amount': 'Amount',
    'summarystep.charge.unknownamount': 'Unknown',
    'summarystep.consent.sid.title':
      'I confirm that the information is correct, and am aware that it is a criminal offense to submit false documentation. I am also aware that if an application for a <b>Seafarer´s identity card is not granted, the fee paid will not be refunded</b>.',
    'summarystep.consent.title':
      'I confirm that the information is correct, and am aware that it is a criminal offense to submit false documentation. I am also aware that if an application for a <b>certificate, evidence or endorsement is not granted, the fee paid will not be refunded</b>.',
    'summarystep.consent.description':
      'I confirm that the information is correct and agree that it can be used for the assessment of certificate applications. I undertake to - not misuse the certificate - to notify the Norwegian Maritime Authority if the requirements for the certificate are no longer met - to return all certificates issued by the Norwegian Maritime Authority in the event of suspension or withdrawal of the certification. I am aware that it is a criminal offense to submit false documentation (cf. § 361 and § 221 of the Criminal Code, and that I will be reported to the police if I submit false documentation). I am also aware that if an application for a certificate, evidence or endorsement is not granted, the fee paid will not be refunded (cf. OR-2009-12-21-1739 § 3). This also applies to applications for the wrong certificate.',
    'summarystep.payment.info':
      'When you go to payment, the application will be locked for 2 hours while we wait for your payment. If you choose not to pay within the time, the application will be opened so that you can edit it again.',
    'qualificationsummary.additionalalternative':
      'Additional qualifications - Alternative {number}',
    'qualificationsummary.error.incomplete': 'Documentation missing or incomplete',
    'whatsNext.heading': 'What happens now?',
    'whatsNext.heading.print': 'Printing certificate',
    'whatsNext.heading.time': 'Delivery estimate',
    'whatsNext.heading.abroad': 'International delivery',
    'whatsNext.info.print':
      'Your certificate is now entered the queue at our printing facilities, where your physical certificate is produced. Meanwhile, your certificate will be visible under «my certificates».',
    'whatsNext.info.time':
      'Certificates are shipped to your address in the national registry as long as you have not chosen shipping to alternate address. If you are unsure you can view the shipment address under «Orderer» on this page. Production is estimated to require 4-5 work days, in addition to the postal service delivery time of 1-4 days, based on where in the country the certificate is being delivered to.',
    'whatsNext.info.abroad':
      'Please note that certificates shipped out of country has somewhat longer delivery time.',
    'courseandeducation.header.description':
      'Here you can find an overview of courses and educations registered for you.<br></br>' +
      'Educational institutions register courses and educations to The Norwegian Maritime Authority.',
    'courseandeducation.subheader.sideinfobox': 'Missing diploma or certificate?',
    'courseandeducation.description.sideinfobox':
      'Contact the issuer of your transcript or diploma if it is not available at “My Page for Seafarers”. ' +
      'You have to option of submitting transcript and or diploma through a certificate application. ' +
      'Note that applications with attachments are processed manually.',
    'back.to.dashboard': 'Go back to dashboard',
    'courseandeducation.notfound': 'No courses were found',
    'courseandeducation.table.hideexpired': 'Hide expired',
    'courseandeducation.table.showexpired': 'Show expired',
    'courseandeducation.table.subheader1': 'Course/education',
    'courseandeducation.table.subheader2': 'Organization',
    'courseandeducation.table.subheader3': 'State',
    'courseandeducation.table.subheader4': 'Completed',
    'courseandeducation.table.subheader5': 'Expiry date',
    'seagoing.title': 'Seagoing time',
    'seagoing.vessel.title': 'Vessel',
    'seagoing.description':
      'Here is an overview of your seagoing time registered electronically by your employer.<br></br>' +
      'Only seagoing time registered in more recent times are available here. Please note that not all shipping companies report electronic seagoing time.<br></br>' +
      'You can not register your own seagoing time here. The Norwegian Maritime Authority does not have the possibility to register seagoing time on behalf of a shipping company.',
    'seagoing.missingseagoingtime': 'Missing seagoing time?',
    'seagoing.missingseagoingtimedescription':
      'In the case of missing or incorrect data we kindly ask you to contact your employer',
    'seagoing.notfound': 'No seagoing time were found',
    'seagoing.table.period': 'Period',
    'seagoing.table.vessel': 'Vessel',
    'seagoing.table.occupation': 'Occupation',
    'seagoing.table.seagoingtime': 'Seagoing time',
    'seagoing.table.totaltimedays': 'Total time (days)',
    'seagoing.table.childtable.vessel': 'Vessel',
    'seagoing.table.childtable.period': 'Period',
    'seagoing.table.childtable.employer': 'Employer',
    'seagoing.ok.tooltip': 'Meets the requirement',
    'seagoing.warning.tooltip': 'Does not meet the requirement',
    'seagoing.days': 'days',
    'seagoing.toggle.showexpired': 'Show expired',
    'seagoing.toggle.show.five.year.old': 'Show seagoing time older than five years',
    'seagoing.toggle.hide.five.year.old': 'Hide seagoing time older than five years',
    'seagoing.loginfo.table.reportedby': 'Reported by',
    'seagoing.loginfo.table.date': 'Date',
    'profile.title': 'My profile',
    'profile.description': 'This is an overview of personal data registered on you.',
    'profile.personalinfo': 'Personal information',
    'profile.personalidentitynumber': 'BirthNumber/D-number',
    'profile.nationality': 'Country',
    'profile.otherinfo': 'Other information',
    'profile.share.title': 'Share my competence',
    'profile.share.search.placeholder': 'Organization ...',
    'profile.share.button': 'Share',
    'profile.share.header': 'Share competence',
    'profile.share.description': 'Do you want to set an expiry date for the sharing?',
    'profile.shared.header': 'Shared',
    'profile.shared.title': 'My shared',
    'profile.shared.requests.title': 'My share requests',
    'profile.shared.table.organization': 'Organization',
    'profile.shared.table.created': 'Created',
    'profile.shared.table.expires': 'Expires',
    'profile.shared.table.status': 'Status',
    'profile.shared.table.status.Approved': 'Approved',
    'profile.shared.table.status.Pending': 'Pending',
    'profile.shared.table.status.Rejected': 'Rejected',
    'profile.shared.noresults.title': 'No active shares',
    'profile.shared.noresults.text':
      'When you share your competence with an organization, it will appear here.',
    'profile.sharerequests.noresults.title': 'No sharing requests:',
    'profile.sharerequests.noresults.text':
      'Here you’ll see requests to share your competencies with an organization.',
    'valid': 'Valid',
    'invalid': 'Invalid',
    'payment.summary.type': 'Type',
    'payment.summary.charge': 'Charge',
    'payment.summary.amount': 'Amount',
    'certificate.overview': 'Certificate overview',
    'certificate.applications.empty': 'No applications found',
    'certificate': 'Certificate',
    'certificate.status.invalid': 'Expired certificate',
    'certificate.status.valid': 'Valid certificate',
    'certificate.app.exists.button': 'Go to started application',
    'certificate.app.exists.head': 'Started application',
    'certificate.app.exists.text':
      'It already exists an application with the same application type that has been started on.',
    'certificate.footer.text.part1':
      'The lawful holder of this endorsement may serve in the capacity listed above or ' +
      'capacities specified in the applicable safe manning requirements of the Administration.',
    'certificate.footer.text.part2': 'Name/ signature of duty authorised official',
    'certificate.create.warning':
      'The application process can take some time. We have received your application and it will soon appear in the overview.',
    'certificate.create.error': 'Could not create application',
    'certificate.create.fetch.error': 'An error has occured',
    'certificate.actions.inactive.heading': 'The certificate have status inactive',
    'certificate.actions.inactive.description': 'The certificate will be valid at: ',
    'certificate.actions.duplicate.heading': 'Order duplicate',
    'certificate.actions.duplicate.description':
      'Charge for issuing duplicate follows regulation of December 21th 2009 nr 1739 ' +
      'covering charges for issuing certificates. See prices in <a>§ 4 in the regulation.</a>',
    'certificate.actions.duplicate.actiontext': 'Order duplicate',
    'certificate.actions.orderprint.heading': 'Order printed certificate',
    'certificate.actions.orderprint.description':
      'There is no additional charge for ordering a printed certificate following ' +
      'regulation of December 21th 2009 nr 1739 covering charges for issuing certificates. ' +
      'See prices in <a>§ 6 in the regulation.</a>',
    'certificate.actions.orderprint.actiontext': 'Order printed certificate',
    'certificate.actions.orderprint.confirmation':
      'Your order has been received. The certificate will be sent within a few days.',
    'certificate.shipmentaddress': 'Shipment address',
    'certificate.printlanguage.label': 'Print language',
    'certificate.printlanguage.english': 'English',
    'certificate.printlanguage.norwegianbokmal': 'Norwegian bokmål',
    'certificate.printlanguage.norwegiannynorsk': 'Norwegian nynorsk',
    'certificate.orderprint.errors.missingaddress': 'Missing address',
    'certificate.print.printordered': 'You have ordered a printed version of this certificate',
    'certificate.printstatus.unprocessed': 'Awaiting processing',
    'certificate.printstatus.notstarted': 'Added to print queue',
    'certificate.printstatus.started': 'Print started',
    'certificate.printstatus.ok': 'Print completed',
    'certificate.printstatus.error': 'Failed in print',
    'certificate.printstatus.unknown': 'Unknown status',
    'certificate.actions.renewal.heading': 'Apply for renewal',
    'certificate.actions.renewal.description':
      'Here you can see processing times for personal certificates: ',
    'certificate.actions.renewal.link':
      'Processing time for personal certificates - Sjøfartsdirektoratet',
    'certificate.actions.renewal.actiontext': 'Apply for renewal',
    'application.status': 'Application status',
    'home.tile.health': 'Health declaration',
    'health.notfound': 'No health declaration were found',
    'health.header.description': 'Here you can see your health declaration.',
    'health.subheader.sideinfobox': 'Missing health declaration?',
    'health.description.sideinfobox':
      'Health declarations for seafarers is registered by an approved seafarer doctor. ' +
      'If the health declaration is unavailable you must contact your seafarer doctor.',
    'competence.header.description':
      'Additional competence needs to be registered by a shipping company. Examples of additional competences:<br></br>' +
      ' • Seagoing time in polar waters<br></br>' +
      ' • Six months of seagoing time associated with bridge watch duty (for the issuance of a deck officer´s certificate)<br></br>' +
      ' • Six months of seagoing time associated with engine watch service (for the issuance of an engine officer´s certificate)<br></br>',
    'competence.subheader.sideinfobox': 'Missing additional competence?',
    'competence.description.sideinfobox':
      'In case of missing or incorrect data we ask you to contact those who reported the additional competence.<br></br>' +
      'You can not report your own additional competence.',
    'competence.notfound': 'No additional competence were found',
    'competence.table.subheader1': 'Vessel',
    'competence.table.subheader2': 'Period',
    'competence.table.subheader3': 'Additional competence',
    'competence.table.subheader4': 'Competence code',
    'competence.table.health.healthcheck': 'Health check',
    'competence.table.health.validTo': 'Valid to',
    'competence.table.health.colorVisionDate': 'Last color vision check',
    'competence.table.health.decision.Fit': 'Valid, without limitations',
    'competence.table.health.decision.FitLimited': 'Valid, with limitations',
    'competence.table.health.limitations': 'Limitations',
    'common.table.vessel': 'Vessel',
    'common.table.periode': 'Period',
    'assessment.header.description':
      'Only approved assessors can register assessments.<br></br>' +
      'Assessments can be registered by assessors on this page {link}',
    'assessment.subheader.sideinfobox': 'Missing assessment?',
    'assessment.description.sideinfobox':
      'In the case of missing or incorrect data we ask you to contact those who have made the assessment.',
    'assessment.notfound': 'No assessment were found',
    'assessment.table.subheader1': 'Date',
    'assessment.table.subheader2': 'Assessor',
    'assessment.table.subheader3': 'Assessment',
    'assessment.table.error': 'Could not get the assessments',
    'health.subComponent.without.limitation': 'Suitable without limitation',
    'health.subComponent.with.limitation': 'Suitable with limitation',
    'health.subComponent.valid': 'Valid until ',
    'health.subComponent.fit.for.bridgeguard': 'Not fit for brideguard',
    'health.subComponent.fit.for.security': 'Not fit for security',
    'health.subComponent.fit.for.other': 'Not fit for other work on board',
    'health.no.found': 'Could not get healthcheck.',
    'health.error': 'An error prevented healthcheck form being retrieved.',
    'vessel.preview.errors.missingvesselid': 'No identification number to look up',
    'application.error.getown.list': 'Could not retrieve applications.',
    'application.error.getown': 'Could not retrieve application.',
    'application.warning.title.timeoutExpired': 'Deadline expired',
    'application.warning.description.timeoutExpired':
      'The deadline for submitting additional information has expired.',
    'application.info.heading':
      'Are you going to submit additional information for a started application, but can´t find your application?',
    'application.info.description':
      'Then it may be that the application has been submitted via Altinn: ',
    'application.info.link':
      'Altinn - Submit supplementary documentation for the application for a personal certificate',
    'application.tile.status.Setup': 'Application started',
    'application.tile.status.AwaitingPayment': 'Application is awaiting payment',
    'application.tile.status.Processing': 'Application submitted for processing',
    'application.tile.status.MoreInfoRequested': 'Application missing documentation',
    'application.tile.status.Approved': 'Application approved',
    'application.tile.status.Rejected': 'Application rejected',
    'application.tile.status.RejectedNotPaid': 'Application ended - missing payment',
    'application.tile.status.Processed': 'Application process completed',
    'application.tile.application.date.submission': 'Application date',
    'application.tile.application.date.created': 'Last saved',
    'application.tile.application.date.timeout': 'Deadline for uploading missing documentation',
    'application.tile.application.lettertext':
      'If you have reserved yourself against digital communication via digital mailbox, you will not be able to receive the decision letter as of now. We are working on a manual dispatch.',
    'application.upload.missing.documentation': 'Upload missing documentation',
    'application.upload.missing.documentation.confirm':
      'Confirm that missing documentation has been uploaded',
    'application.upload.missing.documentation.go.back': 'Go back to application',
    'application.upload.missing.documentation.title.access': 'Not allowed',
    'application.upload.missing.documentation.error.access':
      'The application can not be edited right now. It might be because it is under evaluation or maybe already been approved/rejected.',
    'application.missing.documentation': 'Missing documentation',
    'application.select.qualification.title': 'Select missing qualification to upload',
    'application.delete.confirmation.title': 'Are you sure you want to delete application?',
    'application.delete.confirmation.error': 'Could not delete application',
    'application.lostsid.title': 'Report as lost',
    'application.lostsid.description':
      'Are you sure you want to report this Seafarer´s identity card as lost?',
    'application.lostsid.reason': 'Reason',
    'sailor': 'Sailor',
    'go.to.payment.button': 'Go to payment',
    'go.to.paymentStep.button': 'Go to payment step',
    'go.to.paymentSoltuion.button': 'Go to the paymentsolution',
    'download.paymentreceipt.button': 'Download payment receipt',
    'physical.certificate': 'Physical certificate',
    'physical.certificate.tooltip':
      'If you work on a NOR/NIS vessel in Norwegian waters, the Norwegian Maritime Directorate approves an electronic certificate on board. If you are going to sail on a foreign-flagged vessel or outside Norwegian waters, you must have a physical certificate on board. You can order a physical certificate later if necessary.',
    'physical.certificate.required': 'Require physical certificate',
    'physical.certificate.notrequired': 'Do not require physical certificate',
    'physical.certificate.modal.shipmentaddress.error': 'Could not upload shipment address',
    'app.addfiles.back': 'Back to missing documentation list',
    'app.addfiles.types.application': 'Application',
    'app.addfiles.types.seagoing': 'Seagoing',
    'app.addfiles.types.course': 'Course',
    'app.addfiles.types.education': 'Education',
    'app.addfiles.types.photo': 'Photo',
    'app.addfiles.types.signature': 'Signature',
    'app.addfiles.types.na': 'N/A',
    'app.addfiles.types.photocropped': 'Cropped photo',
    'app.addfiles.types.signaturecropped': 'Cropped signature',
    'app.addfiles.types.Assessment': 'Assessment',
    'app.addfiles.types.AdditionalCompetence': 'Additional competence',
    'app.addfiles.types.HealthCheck': 'Health check',
    'app.addfiles.types.Certificate': 'Certificate',
    'app.addfiles.types.ForeignCourse': 'Foreign course',
    'app.addfiles.types.ForeignId': 'Valid id',
    'app.addfiles.types.NorwegianPassportOrId': 'Valid id',
    'app.addfiles.types.Letter': 'Letter',
    'app.addfiles.types.IssuedCertificate': 'Issued certificate',
    'app.addfiles.types.Confirmation': 'Confirmation',
    'app.addfiles.types.OverRule': 'Overrule',
    'app.addfiles.input.type.label': 'Select attachment type',
    'app.manual.drop.file': 'Drop files to start uploading',
    'app.requirements.table.type': 'Type',
    'app.requirements.table.requirement': 'Requirement',
    'app.requirements.table.upload': 'Upload',
    'app.requirements.type.application': 'Application',
    'app.requirements.obligatoryreqsfor': 'Obligatory requirements for {certificate}',
    'app.requirements.hidecompleted': 'Hide completed',
    'app.requirements.showall': 'Show all',
    'app.requirements.title': 'Requirements',
    'app.requirements.table.applicationrequirement': 'Søknad for {certificate}',
    'app.requirements.table.title': 'Upload missing qualifications',
    'app.requirements.table.header': 'Upload missing qualifications',
    'app.requirements.uploadotherdocuments': 'Upload other documents',
    'app.requirements.status.pending': 'Pending',
    'app.requirements.status.missing': 'Missing',
    'app.requirements.status.valid': 'Valid',
    'app.requirements.status.expired': 'Expired',
    'app.requirements.group.basis': 'Basis',
    'app.requirements.group.alternative': 'Alternative\xa0{number}',
    'app.requirements.group.additional': 'Additional',
    'app.requirements.missing.error.title': 'Missing documentation',
    'app.requirements.missing.error.desc': 'One or more of the requirements needs documentation',
    'app.requirements.state.update.error': 'Could not cofirm upload of documentation',
    'app.requirements.type.seagoing': 'Seagoing',
    'app.requirements.type.course': 'Course',
    'app.requirements.type.education': 'Education',
    'app.requirements.type.certificate': 'Certificate',
    'app.requirements.type.health': 'Health declaration',
    'app.requirements.type.assessment': 'Assessment',
    'app.requirements.type.additionalcompetence': 'Additional competence',
    'app.requirements.type.confirmation': 'Confirmation',
    'app.requirements.type.declaration': 'Declaration',
    'app.requirements.type.idcard': 'ID card',
    'app.requirements.type.profilepicture': 'Profile picture',
    'app.requirements.type.signature': 'Signature',
    'app.requirements.type.foreignid': 'Valid id',
    'app.requirements.type.other': 'Other',
    'app.requirements.errors.missingfiledata': 'Incomplete data for file: {filename}',
    'app.requirements.additionalcompetence.select.placeholder': 'Choose additional competence',
    'app.organization.search': 'Search organization',
    'app.organization.addmanualemployer': 'Add organization manually',
    'app.organization.searchemployer': 'Search for organization',
    'app.organization.newOrganization.name': 'Organization name *',
    'app.organization.newOrganization.type': 'Organization type',
    'app.organization.newOrganization.organizationNumber': 'Organization number or equivalent',
    'app.customerCard.dNumber': 'BirthNumber/D-number',
    'app.additional.competence.completion.date': 'Completion',
    'app.additional.competence.from.date': 'From date',
    'app.additional.competence.to.date': 'To date',
    'app.details.addcompetence.competence': 'Additional competence',
    'app.details.addcompetence.organization': 'Organization',
    'app.requirements.errors.attachmentmissing': 'Attachment missing',
    'certreq.requirements.title': 'Requirements for the certificate',
    'certreq.requirements.intro':
      'Here you can see the requirements for the certificate you are applying for, and how they have been assessed against the information the Norwegian Maritime Authority holds about you. If documentation is missing, you can upload it under the relevant requirement.',
    'certreq.requirements.empty': 'We did not receive a requirement tree for this certificate.',
    'certreq.requirement.untitled': 'Unnamed requirement',
    'certreq.status.pass': 'Fulfilled',
    'certreq.status.fail': 'Not fulfilled',
    'certreq.status.inconclusive': 'Cannot be assessed automatically',
    'certreq.overall.pass': 'All requirements are fulfilled',
    'certreq.overall.fail': 'Some requirements are not fulfilled',
    'certreq.overall.inconclusive': 'Some requirements cannot be assessed automatically',
    'certreq.evaluationdate': 'Assessed as of {date}',
    'certreq.branch.allof': 'All of these',
    'certreq.branch.anyof': 'One of these paths',
    'certreq.branch.oneof': 'Exactly one of these',
    'certreq.branch.not': 'None of these',
    'certreq.reason': 'Reason',
    'certreq.usedservices': 'Seagoing service used',
    'certreq.usedservices.item': 'entry {index} ({days} days)',
    'certreq.upload.title': 'Documentation',
    'certreq.upload.button': 'Upload file',
    'certreq.upload.missingkey':
      'This requirement has no requirement identifier, and cannot receive documentation here. Please contact the Norwegian Maritime Authority.',
    'certreq.upload.error.title': 'The file was not saved',
    'certreq.documented.label': 'Documented',
    'certreq.documented.hint':
      'The documentation you have uploaded is sent to a case officer, and does not change the automatic assessment above.',
    'certreq.error.forbidden.title': 'You do not have access',
    'certreq.error.forbidden.desc':
      'You do not have permission to retrieve the requirements for this certificate. Please try again later, or contact the Norwegian Maritime Authority.',
    'certreq.error.gateway.title': 'The requirements could not be retrieved',
    'certreq.error.gateway.desc': 'The service did not respond. Please try again shortly.',
    'certreq.error.unknown.title': 'The requirements could not be retrieved',
    'certreq.error.unknown.desc':
      'Something went wrong when retrieving the requirements. Please try again.',
    'certreq.requirementtype.education': 'Education',
    'certreq.requirementtype.course': 'Course',
    'certreq.requirementtype.onboardtraining': 'Onboard training',
    'certreq.requirementtype.assessment': 'Assessment',
    'certreq.requirementtype.competency': 'Additional competence',
    'certreq.requirementtype.confirmation': 'Confirmation',
    'certreq.requirementtype.declaration': 'Declaration',
    'certreq.requirementtype.certificate': 'Certificate',
    'certreq.requirementtype.seagoingservice': 'Seagoing service',
    'certreq.requirementtype.age': 'Age',
    'certreq.requirementtype.healthcertificate': 'Medical certificate',
    'certreq.requirementtype.healthcertificaterecreational':
      'Medical certificate for recreational craft masters',
    'certreq.requirementtype.health': 'Health',
    'certreq.requirementtype.yearssincecompletion': 'Years since completion',
    'certreq.requirementtype.dateofcompletion': 'Date of completion',
    'certreq.requirementtype.idcard': 'Identification',
    'certreq.requirementtype.profilepicture': 'Profile picture',
    'certreq.requirementtype.signature': 'Signature',
    'certreq.userview.heading': 'To apply for {certificateName} you must meet these requirements',
    'certreq.userview.loading':
      'We are loading the requirements for this certificate. Please wait.',
    'certreq.userview.status.fulfilled': 'Fulfilled',
    'certreq.userview.status.uploaded': 'Documented',
    'certreq.userview.status.missing': 'Missing',
    'certreq.userview.status.notapplicable': 'Not applicable',
    'certreq.userview.alternatives.heading': 'In addition, one of these alternatives must be met',
    'certreq.userview.atleastoneof': 'At least one of',
    'certreq.userview.exactlyoneof': 'Exactly one of',
    'certreq.userview.grouplogic.allof': 'All of these',
    'certreq.userview.grouplogic.atleastoneof': 'At least one of these',
    'certreq.userview.grouplogic.exactlyoneof': 'Exactly one of these',
    'certreq.userview.upload': 'Upload documentation',
    'certreq.userview.addfile': 'Add file',
    'certreq.userview.uploadfor': 'Upload documentation for {title}',
    'certreq.userview.uploadedfilesfor': 'Attached files for {title}',
    'certreq.userview.removefile': 'Remove {fileName}',
    'certreq.userview.declaration.confirm': 'I confirm the above',
    'certreq.userview.declaration.confirmfor': 'I confirm: {title}',
    'certreq.userview.declaration.locked':
      'The application has been submitted, and the declaration cannot be changed.',
    'certreq.userview.declaration.error':
      'The declaration was not saved. Please try again, or reload the page.',
    'certreq.userview.declaration.missingkey':
      'This requirement has no requirement identifier, and the declaration cannot be saved here. Please contact the Norwegian Maritime Authority.',
    'certreq.userview.declaration.required':
      'You must confirm the required declarations before you can continue. Where there are alternatives, confirming the declarations in one of them is enough.',
    'certreq.userview.declaration.unknown':
      'We could not load the requirements for this certificate, so we do not know whether you need to confirm a declaration before continuing.',
    'certreq.userview.expandgroup': 'Show the requirements under {title}',
    'certreq.userview.collapsegroup': 'Hide the requirements under {title}',
    'certreq.userview.yourpath': 'Your path',
    'certreq.userview.showother': 'Show other alternatives',
    'certreq.userview.hideother': 'Hide other alternatives',
    'certreq.userview.untitled': 'Requirement',
    'certreq.userview.alternativefallback': 'Alternative {number}',
    'certreq.userview.norequirements': 'This certificate has no requirements to show.',
  },
};

export default messages;
